{
	"actions": {
		"title": "Ações",
		"save": "Salvar",
		"edit": "Editar",
		"delete": "Excluir",
		"remove": "Remover",
		"deleting": "Excluindo",
		"see": "Ver",
		"open": "Abrir",
		"back": "Voltar",
		"close": "Fechar",
		"cancel": "Cancelar",
		"download": "Baixar"
	},
	"theme": {
		"light": "Claro",
		"dark": "Escuro",
		"toggle": "Alternar tema"
	},
	"language": "Idioma",
	"auth": {
		"pets": "Pets",
		"logoAriaLabel": "Logo Pets",
		"links": {
			"forgotPassword": "Esqueci a senha",
			"createAccount": "Criar conta",
			"backToLogin": "Voltar para login",
			"alreadyHaveAccount": "Já tenho conta"
		},
		"login": {
			"title": "Login",
			"submit": "Entrar",
			"loadingAria": "Entrando"
		},
		"forgotPassword": {
			"title": "Esqueci a senha",
			"submit": "Enviar token",
			"loadingAria": "Enviando token"
		},
		"resetPassword": {
			"title": "Redefinir senha",
			"submit": "Salvar nova senha",
			"loadingAria": "Salvando nova senha"
		},
		"signup": {
			"title": "Criar conta",
			"submit": "Criar conta",
			"loadingAria": "Criando conta",
			"termsLabel": "Li e aceito os",
			"termsLinkLabel": "termos de uso",
			"options": {
				"referralSource": {
					"indicacao": "Indicação",
					"redesSociais": "Redes sociais",
					"pesquisaGoogle": "Pesquisa no Google",
					"veterinario": "Veterinário",
					"outro": "Outro"
				}
			}
		},
		"verify": {
			"title": "Confirmar e-mail",
			"submit": "Confirmar",
			"submitAria": "Confirmar e-mail",
			"loadingAria": "Confirmando e-mail",
			"resend": "Reenviar token",
			"resending": "Reenviando…",
			"resendIn": "Reenviar em { seconds }s"
		},
		"acceptInvite": {
			"title": {
				"loading": "Aceitar convite",
				"needPassword": "Finalize seu acesso",
				"redirecting": "Redirecionando…"
			},
			"info": {
				"needPassword": "Crie uma senha para concluir o cadastro e acessar o pet.",
				"invitedEmail": "E-mail do convite: <strong>{email}</strong>"
			},
			"loading": {
				"validating": "Validando convite…",
				"redirecting": "Redirecionando…"
			},
			"submit": "Concluir e acessar",
			"submitAria": "Concluir cadastro e acessar",
			"retry": "Tentar novamente",
			"errors": {
				"missing_token": {
					"title": "Link inválido",
					"message": "O link do convite está incompleto. Solicite um novo convite para acessar o sistema."
				},
				"invalid_token": {
					"title": "Convite inválido",
					"message": "Solicite um novo convite para acessar o sistema."
				},
				"invalid_invite": {
					"title": "Convite inválido",
					"message": "Os dados deste convite estão incompletos. Solicite um novo convite ao tutor para acessar o sistema."
				},
				"invite_expired": {
					"title": "Convite expirado",
					"message": "Este convite expirou. Solicite um novo convite ao tutor para acessar o sistema."
				},
				"invite_revoked": {
					"title": "Convite cancelado",
					"message": "Este convite foi cancelado pelo tutor. Solicite um novo convite para acessar o sistema."
				},
				"invite_rejected": {
					"title": "Convite recusado",
					"message": "Este convite foi recusado. Peça um novo convite ao tutor se ainda quiser acessar."
				},
				"invite_used": {
					"title": "Convite já utilizado",
					"message": "Este convite já foi aceito. Faça login para acessar o sistema."
				},
				"user_blocked": {
					"title": "Acesso bloqueado",
					"message": "Sua conta não está habilitada para acessar. Entre em contato com o tutor ou suporte."
				},
				"pet_not_found": {
					"title": "Pet indisponível",
					"message": "O pet deste convite não está mais disponível. Solicite um novo convite ao tutor."
				},
				"bad_request": {
					"title": "Não foi possível processar",
					"message": "Não foi possível processar o convite. Tente abrir o link novamente ou solicite um novo convite."
				},
				"db_error": {
					"title": "Erro ao salvar",
					"message": "Ocorreu um erro ao concluir o cadastro. Tente novamente em alguns instantes."
				},
				"no_jwt": {
					"title": "Não foi possível concluir",
					"message": "Não foi possível iniciar sua sessão. Tente novamente ou faça login."
				},
				"unauthorized": {
					"title": "Sessão expirada",
					"message": "Sua sessão expirou ou é inválida. Tente novamente ou faça login."
				},
				"generic": {
					"title": "Erro ao aceitar convite",
					"message": "Não foi possível concluir o aceite do convite. Tente novamente em alguns instantes."
				}
			}
		},
		"rejectInvite": {
			"title": {
				"loading": "Rejeitar convite",
				"confirm": "Rejeitar convite",
				"done": "Convite rejeitado",
				"error": "Não foi possível rejeitar"
			},
			"info": {
				"confirm": "Tem certeza de que deseja rejeitar este convite para acessar um pet?",
				"fromTutor": "Enviado por {name}"
			},
			"loading": {
				"validating": "Validando convite…"
			},
			"submit": "Rejeitar convite",
			"submitting": "Rejeitando…",
			"success": "Convite rejeitado com sucesso. Você não receberá mais notificações sobre ele.",
			"errors": {
				"missing_token": "O link está incompleto. Abra novamente o e-mail de convite.",
				"invalid_token": "Este convite não é válido ou já foi processado.",
				"invalid_invite": "Os dados deste convite estão incompletos.",
				"invite_expired": "Este convite expirou.",
				"invite_revoked": "Este convite foi cancelado pelo tutor.",
				"invite_rejected": "Este convite já foi rejeitado.",
				"invite_used": "Este convite já foi aceito.",
				"generic": "Não foi possível rejeitar o convite. Tente novamente em alguns instantes."
			}
		},
		"errors": {
			"invalidCredentials": "Credenciais inválidas",
			"emailNotVerified": "Confirme seu e-mail antes de entrar",
			"accountDeleted": "Esta conta foi removida. Entre em contato com o suporte.",
			"accountBlocked": "Esta conta está bloqueada. Entre em contato com o suporte.",
			"loginFailed": "Falha ao entrar",
			"emailInUse": "Esse e-mail já está em uso",
			"passwordConfirmMismatch": "As senhas não conferem",
			"signupFailed": "Falha ao criar conta",
			"tokenExpired": "Token expirou. Solicite outro.",
			"tokenInvalid": "Token inválido",
			"verifyTokenExpired": "Token expirou. Solicite um novo.",
			"verifyTokenInvalid": "Token inválido",
			"verifyResendEmailInvalid": "Informe um e-mail válido para reenviar",
			"verifyResendFailed": "Falha ao reenviar token"
		},
		"messages": {
			"forgotPasswordInfo": "Se existir uma conta com esse e-mail, enviaremos um token.",
			"resetPasswordSuccess": "Senha atualizada. Você já pode entrar.",
			"verifySuccess": "E-mail confirmado. Você já pode entrar.",
			"verifyResendSuccess": "Enviamos um novo token para seu e-mail."
		}
	},
	"emptyState": {
		"generic": {
			"default": {
				"title": "Nenhum resultado encontrado",
				"description": "Tente ajustar os filtros ou criar um novo item.",
				"action": "Criar item",
				"actionAriaLabel": "Criar novo item"
			},
			"search": {
				"title": "Nada encontrado",
				"description": "Tente alterar os filtros ou buscar por outro termo."
			},
			"permission": {
				"title": "Ação indisponível",
				"description": "Você ainda não possui permissão para criar este item."
			}
		},
		"pets": {
			"user": {
				"title": "Muito bom ter você aqui!",
				"description": "Cadastre seu primeiro pet para começar o acompanhamento.",
				"action": "+ Pet",
				"actionAriaLabel": "Cadastrar novo pet"
			},
			"userFiltered": {
				"title": "Nenhum pet encontrado",
				"description": "Não encontramos pets com os filtros atuais. Tente limpar a busca ou alterar espécie/sexo."
			},
			"vet": {
				"title": "Nenhum pet compartilhado ainda",
				"description": "Quando um tutor compartilhar um pet com você, ele aparecerá aqui."
			},
			"master": {
				"title": "Nenhum pet encontrado",
				"description": "Tente limpar os filtros ou selecionar um tutor específico."
			},
			"masterMine": {
				"title": "Você não tem pets cadastrados",
				"description": "Cadastre um pet ou altere o escopo para ver pets de outros tutores."
			},
			"masterMineFiltered": {
				"title": "Nenhum pet encontrado",
				"description": "Não encontramos pets seus com os filtros atuais. Tente limpar a busca ou alterar espécie/sexo."
			},
			"masterWithTutor": {
				"title": "Nenhum pet encontrado para este tutor",
				"description": "Tente limpar os filtros ou selecionar outro tutor."
			},
			"masterWithTutorFiltered": {
				"title": "Nenhum pet encontrado para este tutor",
				"description": "Não encontramos pets deste tutor com os filtros atuais. Tente limpar a busca ou alterar espécie/sexo."
			},
			"masterAll": {
				"title": "Nenhum pet encontrado",
				"description": "Não há pets cadastrados por outros tutores com os filtros atuais."
			},
			"masterAllFiltered": {
				"title": "Nenhum pet encontrado",
				"description": "Não há pets de outros tutores que correspondam aos filtros atuais."
			},
			"onlyWithAlerts": {
				"title": "Nenhum pet com alerta",
				"description": "Não encontramos pets com alertas ativos nos filtros selecionados."
			}
		}
	},
	"form-fields": {
		"email": "E-mail",
		"emailPlaceholder": "seu@email.com",
		"password": "Senha",
		"passwordPlaceholder": "Sua senha",
		"token": "Token",
		"tokenPlaceholder": "Cole o token recebido",
		"newPassword": "Nova senha",
		"newPasswordPlaceholder": "Mínimo 8 caracteres",
		"passwordConfirm": "Confirmar senha",
		"passwordConfirmPlaceholder": "Repita a senha",
		"fullName": "Nome completo",
		"fullNamePlaceholder": "Seu nome",
		"preferredName": "Nome preferido",
		"preferredNamePlaceholder": "Como quer ser chamada",
		"referralSource": "Como conheceu?",
		"referralSourcePlaceholder": "Selecione",
		"referralDetail": "Quem indicou, onde encontrou?",
		"referralDetailPlaceholder": "Ex.: Instagram, amigo, clínica…",
		"measuredAt": "Data da pesagem",
		"weightKg": "Peso (kg)",
		"weightKgPlaceholder": "Ex.: 2,50"
	},
	"validation": {
		"required": "*Campo obrigatório",
		"requiredTerms": "*Aceite os termos para continuar",
		"min": "*Informe um valor maior ou igual ao mínimo permitido",
		"minlength": "*Mínimo de {requiredLength} caracteres",
		"invalidEmail": "*E-mail inválido",
		"invalidValue": "*Valor inválido",
		"invalidDate": "*Data inválida",
		"futureDate": "*A data não pode ser maior do que hoje",
		"adoptionBeforeBirth": "*A data de adoção não pode ser anterior ao nascimento",
		"passwordMismatch": "*As senhas não conferem"
	},
	"form-filter": {
		"title": {
			"list": "Filtrar lista",
			"filterOf": "Filtrar {tipo}"
		},
		"placeholders": {
			"name": "Buscar por nome",
			"species": {
				"title": "Espécie"
			},
			"sex": {
				"title": "Sexo"
			},
			"tutor": {
				"selectTutor": "Selecionar tutor",
				"scope": "Escopo",
				"scopeMine": "Meus pets",
				"scopeAll": "Todos os tutores",
				"search": "Buscar tutor",
				"choose": "Escolha um tutor",
				"noneFound": "Nenhum tutor disponível",
				"lookingPetFrom": "Visualizando pets de:",
				"noneSelectedMine": "Exibindo seus pets.",
				"noneSelectedAll": "Exibindo pets de todos os tutores.",
				"totalPets": "Total de pets:"
			}
		},
		"buttons": {
			"clear": "Limpar",
			"clearSelection": "Limpar seleção",
			"refreshList": "Atualizar lista",
			"onylWithAlerts": "Só pets com alertas"
		},
		"total": "{total, plural, =0{<strong>nenhum pet</strong>} =1{<strong>{total}</strong> pet} other{<strong>{total}</strong> pets}}"
	},
	"home": {
		"alerts": {
			"title": "Alertas",
			"refresh": "Atualizar",
			"refreshing": "Atualizando...",
			"viewMore": "Ver mais",
			"pageTitle": "Alertas",
			"pageSubtitle": "Todos os alertas dos seus pets",
			"pageTitlePet": "Alertas do pet",
			"pageSubtitlePet": "Alertas e pendências deste pet",
			"tabs": {
				"all": "Todos",
				"danger": "Urgentes",
				"warn": "Em breve",
				"info": "Informativos"
			},
			"groups": {
				"danger": "Urgentes",
				"warn": "Em breve",
				"info": "Informativos"
			},
			"empty": {
				"title": "Tudo em dia!",
				"description": "Nenhum alerta foi encontrado para os pets selecionados."
			},
			"preventives": {
				"vermifugo": "Vermífugo",
				"antiPulgas": "Anti-pulgas"
			},
			"items": {
				"birthday": "Aniversário",
				"birthdayWithYears": "Parabéns! {years} anos",
				"vaccine": "Vacina {type}",
				"vaccineAnnualSoon": "A vacinação anual está próxima",
				"vaccineAnnualOverdue": "Vacinação anual em atraso",
				"vaccineIndividualSoon": "Vacina contra {name} em breve",
				"vaccineIndividualOverdue": "Vacina contra {name} em atraso",
				"vaccineMissing": "Nenhuma vacina registrada",
				"glycemia": "Medição glicemia",
				"treatment": "{name}",
				"preventive": "{kind}",
				"preventiveFallback": "Preventivo",
				"visit": "Consulta",
				"weightNever": "Nunca pesou",
				"weightStale": "Sem pesagem há mais de 6 meses"
			},
			"time": {
				"today": "hoje",
				"inDays": "em {days} dias",
				"inDaysWithDate": "em {days} dias · {date}",
				"overdue": "vencido há {days} dias",
				"overdueWithDate": "há {days} dias · prevista em {date}",
				"dueToday": "hoje · {date}",
				"pending": "Pendente",
				"lastWeighing": "última: {date}",
				"withClock": "{label} · {time}"
			}
		}
	},
	"list": {
		"errors": {
			"loadPets": "Não foi possível carregar os pets.",
			"loadAlerts": "Não foi possível carregar os alertas.",
			"loadTutors": "Não foi possível carregar os tutores.",
			"deletePet": "Não foi possível excluir o pet.",
			"leaveSharedPet": "Não foi possível remover o pet da sua lista.",
			"loadMorePets": "Não foi possível carregar mais pets."
		},
		"loadError": {
			"title": "Não foi possível carregar os pets",
			"description": "Verifique sua conexão e tente novamente.",
			"retry": "Tentar novamente"
		},
		"loadingMorePets": "Carregando mais pets...",
		"loadingPetsAria": "Carregando pets",
		"petCard": {
			"tutor": "Tutor",
			"deleteAria": "Excluir pet",
			"leaveAria": "Remover pet da lista",
			"fallbackName": "Pet"
		},
		"deletePet": {
			"title": "Excluir pet?",
			"contentWithName": "Tem certeza que deseja excluir o pet \"{name}\"?",
			"contentGeneric": "Tem certeza que deseja excluir este pet?",
			"confirm": "Excluir",
			"cancel": "Cancelar"
		},
		"leaveSharedPet": {
			"title": "Remover pet da sua lista?",
			"contentWithName": "Tem certeza que deseja remover \"{name}\" da sua lista? Você perderá o acesso a este pet.",
			"contentGeneric": "Tem certeza que deseja remover este pet da sua lista?",
			"confirm": "Remover",
			"cancel": "Cancelar",
			"success": "Pet removido da sua lista."
		},
		"vetInvites": {
			"title": "Pets para aprovar",
			"count": "{count, plural, =0{nenhum convite} =1{1 convite} other{{count} convites}}",
			"refresh": "Atualizar",
			"close": "Fechar",
			"ok": "Ok",
			"approve": "Aprovar",
			"reject": "Recusar",
			"columns": {
				"pet": "Pet",
				"tutor": "Tutor",
				"status": "Status",
				"actions": "Ações"
			},
			"emptyTitle": "Nenhum convite encontrado",
			"emptyDescription": "Quando um tutor compartilhar um pet com você, ele aparecerá aqui.",
			"emailMissing": "Não foi possível identificar o e-mail do usuário no token.",
			"loadFailed": "Não foi possível carregar os convites.",
			"approveSuccess": "Acesso aprovado.",
			"approveFailed": "Não foi possível aprovar o acesso.",
			"rejectTitle": "Recusar convite?",
			"rejectContent": "Você não terá acesso ao pet \"{petName}\". Tutor: {tutor}.",
			"rejectSuccess": "Convite recusado.",
			"rejectFailed": "Não foi possível recusar o convite.",
			"status": {
				"pending": "Pendente",
				"expired": "Expirado",
				"accepted": "Aceito",
				"revoked": "Cancelado",
				"unknown": "—"
			}
		},
		"vaccines": {
			"loading": "Carregando vacinas",
			"close": "Fechar",
			"ok": "Ok",
			"fallbackName": "Vacina",
			"filters": {
				"searchLabel": "Vacina",
				"searchPlaceholder": "Filtrar por vacina ou marca",
				"typeLabel": "Tipo",
				"typePlaceholder": "Tipo de vacina",
				"typeClearAria": "Limpar tipo de vacina",
				"typeSearchPlaceholder": "Buscar tipo de vacina",
				"typeSearchAria": "Buscar tipo de vacina",
				"typeEmpty": "Nenhum tipo encontrado",
				"productLabel": "Produto",
				"productPlaceholder": "Produto / marca comercial",
				"productClearAria": "Limpar produto",
				"productSearchPlaceholder": "Buscar produto",
				"productSearchAria": "Buscar produto",
				"productEmpty": "Nenhum produto encontrado"
			},
			"columns": {
				"vaccine": "Vacina",
				"brand": "Marca",
				"dose": "Dose",
				"administeredAt": "Aplicada em",
				"nextDoseAt": "Próxima dose",
				"professional": "Veterinário",
				"clinic": "Clínica",
				"context": "Contexto",
				"location": "Local",
				"notes": "Observações",
				"actions": "Ações"
			},
			"unknown": "Não informado",
			"empty": {
				"title": "Nenhuma vacina aplicada",
				"description": "Que tal programar a próxima? Proteja o seu pet!"
			},
			"noResults": {
				"title": "Nenhuma vacina encontrada",
				"description": "Tente ajustar os filtros para encontrar o que procura."
			},
			"actions": {
				"editAria": "Editar vacina",
				"deleteAria": "Excluir vacina"
			},
			"delete": {
				"title": "Excluir aplicação de vacina?",
				"contentWithName": "Tem certeza que deseja excluir \"{name}\"?",
				"contentGeneric": "Tem certeza que deseja excluir esta aplicação de vacina?",
				"confirm": "Excluir",
				"cancel": "Cancelar",
				"success": "Vacina excluída com sucesso."
			},
			"errors": {
				"load": "Não foi possível carregar as vacinas.",
				"loadTypes": "Não foi possível carregar os tipos de vacina.",
				"loadProducts": "Não foi possível carregar os produtos de vacina.",
				"delete": "Não foi possível excluir a vacina."
			}
		},
		"preventives": {
			"loading": "Carregando preventivos",
			"protectionDays": "{days} dias",
			"protectionMonths": "{months} meses",
			"filters": {
				"searchLabel": "Preventivo",
				"searchPlaceholder": "Filtrar por produto ou tipo (coleira, pipeta...)",
				"kindLabel": "Tipo",
				"kindPlaceholder": "Qual",
				"kindClearAria": "Limpar tipo"
			},
			"columns": {
				"kind": "Qual",
				"method": "Tipo",
				"product": "Produto",
				"appliedAt": "Aplicada em",
				"nextDueAt": "Próxima dose",
				"protection": "Proteção",
				"notes": "Observações",
				"actions": "Ações"
			},
			"empty": {
				"title": "Nenhum preventivo cadastrado",
				"description": "Cadastre anti-pulgas e vermífugo para lembrar as doses!"
			},
			"noResults": {
				"title": "Nenhum preventivo encontrado",
				"description": "Tente ajustar os filtros para encontrar o que procura."
			},
			"actions": {
				"editAria": "Editar preventivo",
				"deleteAria": "Excluir preventivo"
			},
			"delete": {
				"title": "Excluir preventivo?",
				"contentWithName": "Tem certeza que deseja excluir \"{name}\"?",
				"contentGeneric": "Tem certeza que deseja excluir este preventivo?",
				"confirm": "Excluir",
				"cancel": "Cancelar",
				"success": "Preventivo excluído com sucesso."
			},
			"errors": {
				"load": "Não foi possível carregar os preventivos.",
				"delete": "Não foi possível excluir o preventivo."
			}
		},
		"treatments": {
			"loading": "Carregando tratamentos",
			"close": "Fechar",
			"ok": "Ok",
			"filters": {
				"searchLabel": "Filtro",
				"searchPlaceholder": "Filtrar por medicamento, motivo ou veterinário",
				"statusLabel": "Status",
				"statusPlaceholder": "Status",
				"statusClearAria": "Limpar status"
			},
			"status": {
				"draft": "Rascunho",
				"active": "Ativo",
				"paused": "Pausado",
				"finished": "Finalizado",
				"cancelled": "Cancelado"
			},
			"schedule": {
				"daily": "Diário",
				"dailyTimes": "{count}x ao dia",
				"weekly": "Semanal",
				"monthly": "Mensal"
			},
			"form": {
				"tabsAria": "Tratamento",
				"outerTabsAria": "Seções do plano de tratamento",
				"planSection": "Dados do plano",
				"itemsSection": "Itens do plano",
				"itemsTabAria": "Itens do tratamento",
				"itemLabel": "Item {number}",
				"tabs": {
					"plan": "Plano",
					"items": "Itens",
					"general": "Geral",
					"frequency": "Frequência e horários",
					"dose": "Dose",
					"validity": "Validade",
					"package": "Embalagem e estoque",
					"notes": "Notas"
				},
				"fields": {
					"planName": "Nome do plano",
					"generalInstructions": "Instruções gerais",
					"itemName": "Nome do item",
					"details": "Detalhes",
					"medName": "Medicamento",
					"medPresentation": "Apresentação",
					"medManufacturer": "Fabricante",
					"conditions": "Condições clínicas",
					"startedAt": "Início",
					"estimatedEndDate": "Término estimado",
					"visit": "Consulta",
					"veterinarian": "Veterinário",
					"vetOther": "Outro",
					"vetCrmv": "CRMV",
					"durationMode": "Duração",
					"durationDays": "Em dias",
					"hasPause": "Intervalo no tratamento",
					"pauseDays": "Dias de pausa",
					"durationAgain": "Duração novamente (dias)",
					"untilDate": "Data final",
					"vetName": "Veterinário",
					"reason": "Motivo",
					"frequencyMode": "Frequência",
					"times": "Horários",
					"time": "Horário",
					"weeklyWeekdays": "Dias da semana",
					"monthlyMonthdays": "Dias do mês",
					"doseValue": "Dose",
					"doseUnit": "Unidade",
					"doseRoute": "Via",
					"isInsulin": "Insulina",
					"insulinKind": "Tipo de insulina",
					"insulinConcentration": "Concentração",
					"insulinDelivery": "Apresentação",
					"openedAt": "Aberto em",
					"openedValidDays": "Dura após abrir (dias)",
					"discardAt": "Descartar em",
					"expiresAt": "Vencimento",
					"amountTotal": "Quantidade total",
					"amountUnit": "Unidade",
					"amountRemaining": "Restante",
					"lowStockThreshold": "Alerta baixo estoque",
					"noteText": "Adicionar nota"
				},
				"placeholders": {
					"conditions": "Selecione uma ou mais condições",
					"visit": "Vincular a uma consulta",
					"select": "Selecione",
					"doseUnit": "ex.: UI, mg, ml",
					"doseRoute": "ex.: oral, SC",
					"amountUnit": "ex.: ml, comprimidos"
				},
				"linkedPreventivesTitle": "Preventivos vinculados",
				"hints": {
					"noConditions": "Nenhuma condição cadastrada ainda.",
					"noteSaveWithTreatment": "Esta nota será salva junto com o tratamento quando você clicar em “Salvar”.",
					"visitLocked": "Consulta definida pela prescrição e não pode ser alterada."
				},
				"actions": {
					"addItem": "Adicionar item",
					"removeItem": "Remover item",
					"removeTime": "Remover",
					"addTime": "Adicionar horário",
					"saveNote": "Salvar nota",
					"registerPreventive": "Registrar como preventivo"
				},
				"duration": {
					"indefinite": "Indefinido",
					"continuous": "Contínuo",
					"for_days": "Por dias",
					"until_date": "Até uma data"
				},
				"frequency": {
					"daily": "Diário",
					"weekly": "Semanal",
					"monthly": "Mensal"
				},
				"weekdays": {
					"0": "Dom",
					"1": "Seg",
					"2": "Ter",
					"3": "Qua",
					"4": "Qui",
					"5": "Sex",
					"6": "Sáb"
				},
				"insulin": {
					"kind": {
						"glargine": "Glargina",
						"pzi": "PZI / ProZinc",
						"lente": "Lente (Vetsulin)",
						"nph": "NPH",
						"detemir": "Detemir",
						"other": "Outro"
					},
					"concentration": {
						"U40": "U-40",
						"U100": "U-100",
						"other": "Outra"
					},
					"delivery": {
						"vial": "Frasco",
						"pen": "Caneta",
						"cartridge": "Cartucho"
					}
				},
				"errors": {
					"scheduleRequired": "Preencha a frequência e pelo menos um horário.",
					"durationDaysRequired": "Informe a quantidade de dias.",
					"untilDateRequired": "Informe a data final.",
					"vetRequired": "Informe o nome e o CRMV do veterinário."
				},
				"successSave": "Tratamento cadastrado com sucesso.",
				"successEdit": "Tratamento atualizado com sucesso.",
				"errorSave": "Não foi possível salvar o tratamento."
			},
			"validity": {
				"opened": "Aberto",
				"discard": "Descartar"
			},
			"columns": {
				"startedAt": "Início",
				"medication": "Plano / tratamento",
				"items": "Itens",
				"vet": "Veterinário",
				"dose": "Dose",
				"schedule": "Frequência",
				"validity": "Validade após abrir",
				"status": "Status",
				"actions": "Ações"
			},
			"empty": {
				"title": "Nenhum tratamento cadastrado",
				"description": "Cadastre um tratamento e acompanhe as doses e validade."
			},
			"noResults": {
				"title": "Nenhum tratamento encontrado",
				"description": "Tente ajustar os filtros para encontrar o que procura."
			},
			"actions": {
				"editAria": "Editar tratamento",
				"viewAria": "Ver tratamento",
				"pauseAria": "Pausar tratamento",
				"reactivateAria": "Reativar tratamento",
				"finishAria": "Finalizar tratamento",
				"deleteAria": "Excluir tratamento"
			},
			"pause": {
				"success": "Tratamento pausado."
			},
			"reactivate": {
				"success": "Tratamento reativado."
			},
			"finish": {
				"title": "Finalizar tratamento?",
				"contentWithName": "Tem certeza que deseja finalizar \"{name}\"?",
				"contentGeneric": "Tem certeza que deseja finalizar este tratamento?",
				"confirm": "Finalizar",
				"cancel": "Cancelar",
				"success": "Tratamento finalizado."
			},
			"delete": {
				"title": "Excluir tratamento?",
				"contentWithName": "Tem certeza que deseja excluir \"{name}\"? Essa ação não poderá ser desfeita.",
				"contentGeneric": "Tem certeza que deseja excluir este tratamento? Essa ação não poderá ser desfeita.",
				"confirm": "Excluir",
				"cancel": "Cancelar",
				"success": "Tratamento excluído."
			},
			"errors": {
				"load": "Não foi possível carregar os tratamentos.",
				"status": "Não foi possível atualizar o status do tratamento.",
				"delete": "Não foi possível excluir o tratamento."
			}
		},
		"consultations": {
			"loading": "Carregando consultas",
			"close": "Fechar",
			"ok": "Ok",
			"filters": {
				"visitedFromLabel": "Data consulta (de)",
				"visitedToLabel": "Data consulta (até)",
				"nextVisitFromLabel": "Data retorno (de)",
				"nextVisitToLabel": "Data retorno (até)",
				"kindLabel": "Tipo consulta",
				"kindPlaceholder": "Tipo",
				"kindClearAria": "Limpar tipo de consulta",
				"modeLabel": "Modelo da consulta",
				"modePlaceholder": "Modelo",
				"modeClearAria": "Limpar modelo da consulta",
				"vetLabel": "Veterinário",
				"vetPlaceholder": "Nome ou CRMV",
				"clinicLabel": "Clínica",
				"clinicPlaceholder": "Filtrar por clínica"
			},
			"form": {
				"tabsAria": "Abas do formulário de consulta",
				"tabs": {
					"general": "Informações gerais",
					"history": "Relato e exame físico",
					"vaccines": "Vacina",
					"exams": "Exames",
					"diagnosis": "Hipóteses e diagnósticos",
					"conduct": "Condutas realizadas",
					"prescription": "Prescrição e orientações",
					"documents": "Documentos",
					"finance": "Financeiro"
				},
				"visitedAtDate": "Data da visita",
				"visitedAtTime": "Horário",
				"visitType": "Tipo",
				"visitMode": "Modelo",
				"clinic": "Clínica",
				"clinicPlaceholder": "Buscar clínica ou local",
				"clinicOther": "Outro",
				"clinicName": "Nome da clínica / local",
				"clinicNamePlaceholder": "Ex.: Clínica X",
				"veterinarian": "Veterinário",
				"vetPlaceholder": "Buscar por nome ou CRMV",
				"vetOther": "Outro",
				"vetName": "Nome do veterinário",
				"vetNamePlaceholder": "Nome completo",
				"vetCrmv": "CRMV",
				"vetCrmvPlaceholder": "Ex.: CRMV-SP 12345",
				"nextVisitAt": "Data de retorno",
				"returnReason": "Objetivo do retorno",
				"reason": "Motivo da consulta",
				"reasonPlaceholder": "Ex.: vômito, check-up, retorno",
				"notes": "Notas da consulta",
				"weightKg": "Peso (kg)",
				"tempC": "Temperatura (°C)",
				"tempLo": "LOW/LO (sem temperatura)",
				"tempLoTooltip": "Marque quando o termômetro não conseguiu medir a temperatura (valor abaixo da escala ou leitura inválida). A temperatura não será registrada.",
				"relatedVisit": "Consulta de origem",
				"relatedVisitPlaceholder": "Selecione a consulta anterior",
				"heartRateBpm": "Frequência cardíaca (bpm)",
				"respRateBpm": "Frequência respiratória (irpm)",
				"capillaryRefillSec": "Tempo de preenchimento capilar (s)",
				"systolicBloodPressure": "Pressão arterial sistólica (mmHg)",
				"mucousMembrane": "Mucosas",
				"hydrationStatus": "Hidratação",
				"bodyConditionScore": "Escore corporal",
				"bodyConditionScale": "Escala do escore corporal",
				"historyText": "Histórico relatado pelo tutor",
				"reportedSigns": "Sinais percebidos pelo tutor",
				"painReported": "Tutor percebeu dor?",
				"painDetails": "Detalhes da dor relatada",
				"examSummary": "Resumo do exame",
				"findings": "Achados do exame físico",
				"generalConduct": "Conduta geral realizada na consulta",
				"examRequests": "Exames solicitados",
				"examRequestsPlaceholder": "Selecione pacotes e exames",
				"examPanelPrefix": "Pacote:",
				"otherExamTitle": "Outro exame (fora do catálogo)",
				"otherExamHint": "Use quando o exame pedido não estiver no catálogo.",
				"otherExamName": "Nome do exame",
				"otherExamNamePlaceholder": "Ex.: Painel hepático completo",
				"otherExamNameRequired": "Informe o nome do exame para adicionar.",
				"otherExamKind": "Tipo (opcional)",
				"otherExamKindNone": "Não informado",
				"otherExamKindPlaceholder": "Selecione o tipo",
				"otherExamNotes": "Observação (opcional)",
				"otherExamNotesPlaceholder": "Detalhes da solicitação",
				"otherExamAdd": "Adicionar outro exame",
				"freeExamTitle": "Título livre / pedido documental",
				"freeExamTitlePlaceholder": "Ex.: Pedido de exames da clínica X",
				"documentOnlyRequest": "Solicitação só documental (sem itens estruturados)",
				"diagnosis": "Diagnóstico",
				"conditionOr": "OU",
				"conditionLink": "Vincular condição existente",
				"conditionLinkPlaceholder": "Buscar condição do pet",
				"conditionDiagnosisNote": "Diagnóstico (nota)",
				"conditionDiagnosisNotePlaceholder": "Descreva o diagnóstico clínico",
				"conditionNameRequired": "Informe o nome da condição ou vincule uma existente para salvar os dados da condição clínica.",
				"diagnosisName": "Hipótese ou diagnóstico",
				"diagnosisStatus": "Status",
				"diagnosisNotes": "Observações",
				"newConditionName": "Criar condição com o nome",
				"addDiagnosis": "Adicionar hipótese ou diagnóstico",
				"proceduresDone": "Procedimentos realizados",
				"medsAdministered": "Medicamentos aplicados",
				"prescriptionOriginal": "Texto original da prescrição",
				"prescriptionSource": "Origem da prescrição",
				"prescriptionGeneralInstructions": "Orientações gerais",
				"prescriptionItemType": "Tipo da orientação",
				"prescriptionItemName": "Nome",
				"doseText": "Dose",
				"frequencyText": "Frequência",
				"durationText": "Duração",
				"route": "Via",
				"prescriptionItemInstructions": "Instruções",
				"addPrescriptionItem": "Adicionar item à prescrição",
				"createTreatmentFromPrescription": "Criar tratamento a partir da prescrição",
				"treatmentFromPrescriptionSuccess": "Plano de tratamento criado a partir da prescrição.",
				"treatmentFromPrescriptionError": "Não foi possível criar o tratamento a partir da prescrição.",
				"prescriptionUpload": "Anexos da prescrição",
				"diagnosisUpload": "Laudos e documentos deste diagnóstico",
				"examUpload": "Anexos da solicitação de exames",
				"financeUpload": "Comprovantes e notas fiscais",
				"uploadDropzone": "Arraste arquivos aqui ou selecione no dispositivo",
				"uploadBrowse": "Selecionar arquivos",
				"uploadConstraints": "PDF, JPG, PNG ou WEBP de até 10 MB por arquivo",
				"uploadAddMore": "Adicionar mais arquivos",
				"uploadInvalidType": "Formato de arquivo não permitido.",
				"uploadTooLarge": "O arquivo excede o limite de __MAX_SIZE__.",
				"uploadDocument": "Enviar documento (PDF ou imagem)",
				"documentsEmpty": "Nenhum documento anexado a esta consulta.",
				"documentUploadSuccess": "Documento enviado.",
				"documentUploadError": "Não foi possível enviar o documento.",
				"documentDeleteError": "Não foi possível excluir o documento.",
				"documentOpenError": "Não foi possível abrir o documento.",
				"costTotal": "Custo total",
				"paidTotal": "Valor pago",
				"paymentMethod": "Forma de pagamento",
				"successSave": "Consulta cadastrada com sucesso.",
				"successEdit": "Consulta atualizada com sucesso.",
				"errorSave": "Não foi possível salvar a consulta.",
				"weightReplaceTitle": "Peso diferente já cadastrado neste dia",
				"weightReplaceDescription": "Já existe peso de {existing} kg neste dia, e a consulta informa {next} kg. O que deseja fazer?",
				"weightReplaceConfirm": "Usar o peso da consulta",
				"weightReplaceSkip": "Manter o peso já cadastrado",
				"documentViewImage": "Ver imagem",
				"documentOpenFile": "Abrir arquivo",
				"documentDeleteSuccess": "Documento removido.",
				"documentZoomIn": "Aumentar zoom",
				"documentZoomOut": "Diminuir zoom",
				"documentZoomReset": "{zoom}%",
				"financeDocumentDescription": "Comprovante financeiro",
				"weightDuplicateDay": "Já existe peso registrado nesse dia",
				"documentsPrescriptionLabel": "Prescrições",
				"documentsFinanceLabel": "Comprovantes financeiros",
				"documentsExamLabel": "Anexos de exames",
				"documentsDiagnosisLabel": "Documentos do diagnóstico",
				"documentDownloadError": "Não foi possível baixar o documento."
			},
			"kinds": {
				"routine": "Rotina",
				"follow_up": "Retorno",
				"return": "Retorno",
				"urgent": "Urgência",
				"emergency": "Emergência",
				"monitoring": "Acompanhamento",
				"preoperative": "Pré-operatório",
				"postoperative": "Pós-operatório",
				"vaccination": "Vacinação",
				"exam": "Avaliação de exame",
				"other": "Outro"
			},
			"modes": {
				"clinic": "Clínica",
				"home": "Domicílio",
				"telehealth": "Teleatendimento",
				"campaign": "Campanha",
				"shelter": "Abrigo",
				"other": "Outro"
			},
			"pain": {
				"yes": "Sim",
				"no": "Não",
				"unknown": "Não soube informar"
			},
			"diagnosisStatus": {
				"suspected": "Suspeita",
				"under_investigation": "Em investigação",
				"probable": "Provável",
				"confirmed": "Confirmado",
				"ruled_out": "Descartado",
				"known_condition": "Condição já conhecida",
				"other": "Outro"
			},
			"prescriptionTypes": {
				"medication": "Medicamento",
				"fluid_therapy": "Fluidoterapia",
				"physiotherapy": "Fisioterapia",
				"supplement": "Suplemento",
				"diet": "Dieta",
				"home_care": "Cuidado em casa",
				"monitoring": "Monitoramento",
				"restriction": "Restrição",
				"follow_up": "Retorno",
				"other": "Outro"
			},
			"prescriptionSources": {
				"written": "Receita escrita",
				"verbal": "Orientação verbal",
				"attachment": "Anexo",
				"clinic_report": "Relatório da clínica",
				"tutor_notes": "Anotação do tutor",
				"other": "Outro"
			},
			"reportedSigns": {
				"apathy": "Apatia",
				"perceived_fever": "Febre percebida",
				"vomiting": "Vômito",
				"diarrhea": "Diarreia",
				"itching": "Coceira",
				"loss_of_appetite": "Perda de apetite",
				"increased_appetite": "Aumento de apetite",
				"increased_thirst": "Aumento de sede",
				"increased_urination": "Aumento de urina",
				"difficulty_urinating": "Dificuldade para urinar",
				"cough": "Tosse",
				"difficulty_breathing": "Dificuldade para respirar",
				"difficulty_walking": "Dificuldade para andar",
				"discharge": "Secreção",
				"bleeding": "Sangramento",
				"behavior_change": "Mudança de comportamento",
				"pain": "Dor",
				"other": "Outro"
			},
			"columns": {
				"visitedAt": "Data consulta",
				"nextVisitAt": "Data retorno",
				"kind": "Tipo",
				"mode": "Modelo",
				"vet": "Veterinário",
				"clinic": "Clínica",
				"links": "Vínculos",
				"notes": "Notas",
				"actions": "Ações"
			},
			"links": {
				"separator": " · ",
				"vaccine": "{count} vacina",
				"vaccines": "{count} vacinas",
				"exam": "{count} exame",
				"exams": "{count} exames",
				"condition": "{count} condição",
				"conditions": "{count} condições"
			},
			"empty": {
				"title": "Nenhuma consulta cadastrada",
				"description": "Que tal marcar um check-up pro seu pet?"
			},
			"noResults": {
				"title": "Nenhuma consulta encontrada",
				"description": "Tente ajustar os filtros para encontrar o que procura."
			},
			"actions": {
				"editAria": "Editar consulta",
				"deleteAria": "Excluir consulta"
			},
			"delete": {
				"title": "Excluir consulta?",
				"contentGeneric": "Essa ação não poderá ser desfeita.",
				"confirm": "Excluir",
				"cancel": "Cancelar",
				"success": "Consulta excluída."
			},
			"errors": {
				"load": "Não foi possível carregar as consultas.",
				"delete": "Não foi possível excluir a consulta."
			}
		},
		"glycemia": {
			"loading": "Carregando curvas glicêmicas",
			"tabsAria": "Abas de glicemia",
			"tabs": {
				"daily": "Diária",
				"curve": "Curva",
				"compare": "Comparação"
			},
			"close": "Fechar",
			"ok": "Ok",
			"columns": {
				"date": "Data",
				"startTime": "Início",
				"clicks": "Dose (UI)",
				"dose": "Dose (UI)",
				"pointsRecorded": "Pontos",
				"notes": "Observações",
				"actions": "Ações"
			},
			"pointsRecordedValue": "{count}/5",
			"doseUnit": "UI",
			"now": "agora",
			"pointGlucosePlaceholder": "ex.: 122 ou HI",
			"form": {
				"date": "Data",
				"startTime": "Horário inicial",
				"warnMinutes": "Alerta (min antes)",
				"warnMinutesTooltip": "Tempo usado apenas para notificações Web Push. Na Visão Geral, medições próximas entram em \"Em breve\" com regra fixa de 1 hora antes do horário.",
				"warnMinutesReadonly": "Alerta Web Push (min antes)",
				"doseUi": "Dose de insulina (UI)",
				"autoScheduleHint": "Pontos automáticos a cada 3h: {t1}, {t2}, {t3}, {t4}, {t5}",
				"sessionCreateSuccess": "Curva glicêmica cadastrada com sucesso.",
				"sessionErrorSave": "Não foi possível cadastrar a curva glicêmica."
			},
			"empty": {
				"title": "Nenhuma curva glicêmica realizada",
				"description": "Registre uma curva para acompanhar a resposta à dosagem."
			},
			"actions": {
				"openAria": "Abrir medição",
				"deleteAria": "Excluir medição"
			},
			"delete": {
				"title": "Excluir medição?",
				"contentWithDate": "Excluir definitivamente a medição de {date} com os valores individuais?",
				"contentGeneric": "Excluir definitivamente esta medição com os valores individuais?",
				"confirm": "Excluir",
				"cancel": "Cancelar",
				"success": "Medição excluída com sucesso."
			},
			"errors": {
				"load": "Não foi possível carregar as curvas glicêmicas.",
				"delete": "Não foi possível excluir a medição.",
				"pointGlucoseAndTimeRequired": "Informe a glicemia e o horário para salvar o ponto.",
				"pointSave": "Não foi possível salvar o ponto da curva.",
				"glucoseConflictTitle": "Glicemia diferente no mesmo horário",
				"glucoseConflictDescription": "Já existe leitura diária de {existing} neste horário. A curva informa {next}. O que deseja fazer?",
				"glucoseConflictConfirm": "Usar valor da curva",
				"glucoseConflictKeep": "Manter valor do diário"
			},
			"daily": {
				"loading": "Carregando glicemia diária",
				"type": "Leitura",
				"newTitle": "Nova leitura diária",
				"newSubtitle": "Registre a glicemia do dia a dia",
				"editTitle": "Editar leitura diária",
				"editSubtitle": "Atualize glicemia, horário e insulina",
				"dateLockedHint": "A data não pode ser alterada. Ajuste apenas o horário, a glicemia e a insulina.",
				"createSuccess": "Leitura salva com sucesso.",
				"updateSuccess": "Leitura atualizada com sucesso.",
				"chartName": "Glicemia",
				"chartRange": {
					"label": "Período do gráfico",
					"d7": "7 dias",
					"d15": "15 dias",
					"d30": "30 dias",
					"custom": "Personalizado",
					"from": "De",
					"to": "Até",
					"apply": "Aplicar",
					"panelTitle": "Gráfico do período",
					"min": "Menor valor: {value} mg/dL",
					"max": "Maior valor: {value} mg/dL",
					"minPrefix": "Menor valor",
					"maxPrefix": "Maior valor",
					"lowestPeriod": "Período mais baixo: {period}",
					"highestPeriod": "Período mais alto: {period}",
					"lowestPeriodPrefix": "Período mais baixo",
					"highestPeriodPrefix": "Período mais alto",
					"periodDawn": "Madrugada (00h–06h)",
					"periodMorning": "Manhã (06h–12h)",
					"periodAfternoon": "Tarde (12h–18h)",
					"periodNight": "Noite (18h–00h)",
					"periodUnknown": "Sem dados suficientes",
					"measurementsCountLabel": "Medições no período",
					"measurementsCount": "Medições no período: {count}",
					"insulinAppliedLabel": "Insulinas aplicadas",
					"rangeTooLong": "O período personalizado pode ter no máximo 6 meses. Escolha um intervalo menor.",
					"loLegend": "LO (< 20/10 mg/dL)",
					"hiLegend": "HI (> 500/600 mg/dL)",
					"loCountLabel": "Medições LO",
					"hiCountLabel": "Medições HI",
					"flagsNote": "Também no período: {flags}",
					"generatePdf": "Gerar PDF",
					"pdfTitle": "Glicemia diária",
					"pdfPeriod": "Período: {from} a {to}",
					"pdfFileName": "glicemia-diaria-{from}_{to}.pdf",
					"pdfError": "Não foi possível gerar o PDF.",
					"pdfColumns": {
						"date": "Data",
						"time": "Hora",
						"glucose": "mg/dL",
						"insulin": "Dose insulina",
						"notes": "Observações"
					}
				},
				"hiLabel": "HI (acima do limite do aparelho)",
				"loLabel": "LO (abaixo do limite do aparelho)",
				"glucoseMode": {
					"value": "Valor",
					"lo": "LO",
					"hi": "HI"
				},
				"columns": {
					"time": "Hora",
					"glucose": "mg/dL",
					"insulin": "Insulina"
				},
				"insulin": {
					"yes": "Aplicada",
					"no": "Não aplicada",
					"notRegistered": "Não registrada",
					"notAdministered": "Não apliquei insulina",
					"notAdministeredHint": "Marque se decidiu não aplicar. Se deixar a dose em branco sem marcar, o sistema considera que a dose não foi registrada."
				},
				"empty": {
					"title": "Nenhuma leitura diária",
					"description": "Registre a glicemia do dia a dia para acompanhar o controle."
				},
				"actions": {
					"deleteAria": "Excluir leitura",
					"editAria": "Editar leitura",
					"deleteLockedTooltip": "Registros gerados pela curva glicêmica só podem ser excluídos por administrador"
				},
				"delete": {
					"title": "Excluir leitura?",
					"content": "Excluir definitivamente esta leitura diária?",
					"success": "Leitura excluída com sucesso."
				},
				"errors": {
					"load": "Não foi possível carregar a glicemia diária.",
					"loadOne": "Não foi possível carregar a leitura.",
					"save": "Não foi possível salvar a leitura.",
					"delete": "Não foi possível excluir a leitura.",
					"glucoseRequired": "Informe o valor da glicemia ou marque LO ou HI.",
					"duplicateDateTime": "Já existe leitura nesse dia e hora.",
					"duplicateSameValue": "Já existe leitura com o mesmo valor nesse dia e hora.",
					"glucoseConflictTitle": "Glicemia diferente no mesmo horário",
					"glucoseConflictDescription": "Já existe leitura de {existing} neste horário. O novo valor é {next}. O que deseja fazer?",
					"glucoseConflictConfirm": "Usar o novo valor",
					"glucoseConflictKeep": "Manter o valor existente"
				}
			},
			"compare": {
				"insufficientTitle": "Medições insuficientes",
				"insufficientDescription": "É necessário ter ao menos 2 curvas glicêmicas registradas para comparar.",
				"measurementA": "Medição A",
				"measurementB": "Medição B",
				"measurementC": "Medição C",
				"select": "Selecione",
				"selectOptional": "Selecione",
				"threshold": "Limiar de diferença",
				"run": "Comparar",
				"note": "Nota",
				"formPanelTitle": "Selecionar medições",
				"seriesNamed": "{label} ({date})",
				"hiDisplay": "HI (600+)",
				"notes": {
					"lower": "menor",
					"higher": "maior",
					"equal": "igual",
					"atLeast": "Pelo menos {delta}"
				}
			}
		},
		"conditions": {
			"loading": "Carregando condições clínicas",
			"close": "Fechar",
			"ok": "Ok",
			"columns": {
				"name": "Nome",
				"curability": "Curabilidade",
				"status": "Status",
				"severity": "Severidade",
				"diagnosedAt": "Diagnosticado em",
				"actions": "Ações"
			},
			"curability": {
				"CURÁVEL": "Com cura",
				"NÃO_CURÁVEL": "Sem cura",
				"INDEFINIDO": "Em avaliação"
			},
			"status": {
				"ATIVA": "Ativa",
				"RESOLVIDA": "Resolvida",
				"EM_MANEJO": "Em tratamento",
				"DESCARTADA": "Descartada"
			},
			"severity": {
				"BAIXA": "Baixa",
				"MODERADA": "Moderada",
				"ALTA": "Alta"
			},
			"conditionType": {
				"AGUDA": "Aguda",
				"CRÔNICA": "Crônica",
				"CONGÊNITA": "Congênita",
				"RECORRENTE": "Recorrente",
				"DESCONHECIDA": "Desconhecida"
			},
			"bodySystem": {
				"ENDÓCRINO": "Endócrino",
				"RENAL": "Renal",
				"CARDÍACO": "Cardíaco",
				"RESPIRATÓRIO": "Respiratório",
				"GASTROINTESTINAL": "Gastrointestinal",
				"NEUROLÓGICO": "Neurológico",
				"OSTEOARTICULAR": "Osteoarticular",
				"DERMATOLÓGICO": "Dermatológico",
				"HEMATOLÓGICO": "Hematológico",
				"OFTÁLMICO": "Oftálmico",
				"OUTRO": "Outro"
			},
			"controlStatus": {
				"BEM_CONTROLADA": "Bem controlada",
				"PARCIALMENTE_CONTROLADA": "Parcialmente controlada",
				"DESCOMPENSADA": "Descompensada"
			},
			"lifeRisk": {
				"BAIXO": "Baixo",
				"MODERADO": "Moderado",
				"ALTO": "Alto",
				"EMERGENCIAL": "Emergencial"
			},
			"form": {
				"name": "Nome da condição",
				"curability": "Curabilidade",
				"status": "Status",
				"severity": "Severidade",
				"conditionType": "Tipo da condição",
				"bodySystem": "Sistema / órgão principal",
				"controlStatus": "Situação de controle",
				"lifeRisk": "Risco de vida associado",
				"symptomStartAt": "Início dos sintomas",
				"diagnosedAt": "Diagnosticado em",
				"resolvedAt": "Resolvida em",
				"notes": "Nota inicial",
				"followupPlan": "Plano de acompanhamento",
				"successSave": "Condição cadastrada com sucesso.",
				"successEdit": "Condição atualizada com sucesso.",
				"errorSave": "Não foi possível salvar a condição."
			},
			"details": {
				"tabs": {
					"aria": "Abas da condição clínica",
					"general": "Informações gerais",
					"notes": "Notas",
					"links": "Vínculos"
				},
				"infoTitle": "Informações",
				"notesTitle": "Notas",
				"linksTitle": "Vínculos",
				"noteFormTitle": "Cadastrar nota",
				"noteFormEditTitle": "Editar nota",
				"noteContent": "Nota",
				"notePlaceholder": "Escreva uma nota",
				"recordedAt": "Registrado em",
				"addNote": "Adicionar nota",
				"sortLabel": "Ordenação",
				"sortDesc": "Mais recentes primeiro",
				"sortAsc": "Mais antigas primeiro",
				"notesEmpty": "Nenhuma nota",
				"notesEmptyTitle": "Nenhuma nota",
				"notesEmptyDescription": "Cadastre a primeira nota para acompanhar a evolução desta condição.",
				"columns": {
					"recordedAt": "Data",
					"content": "Nota",
					"status": "Status",
					"severity": "Severidade",
					"actions": "Ações"
				},
				"labResults": "Resultados de exame",
				"labResultPlaceholder": "Selecionar resultado",
				"treatments": "Tratamentos",
				"treatmentPlaceholder": "Selecionar tratamento",
				"link": "Vincular",
				"deleteNoteTitle": "Apagar nota?",
				"deleteNoteWithPreview": "Essa ação não pode ser desfeita. Nota: \"{preview}\"",
				"deleteNoteGeneric": "Essa ação não pode ser desfeita.",
				"historyNotePrefix": "Atualização clínica: {changes}",
				"historyChange": "{field}: {from} → {to}",
				"historyEmpty": "não informado",
				"saveSuccess": "Condição atualizada com sucesso.",
				"saveError": "Não foi possível atualizar a condição."
			},
			"empty": {
				"title": "Nenhuma condição encontrada",
				"description": "Aqui é o lugar ideal para acompanhar as necessidades do seu pet!"
			},
			"actions": {
				"openAria": "Abrir condição",
				"deleteAria": "Excluir condição"
			},
			"delete": {
				"title": "Apagar condição clínica?",
				"contentWithName": "Essa ação não pode ser desfeita. Condição: \"{name}\"",
				"contentGeneric": "Essa ação não pode ser desfeita.",
				"confirm": "Apagar",
				"cancel": "Cancelar",
				"success": "Condição excluída com sucesso."
			},
			"errors": {
				"load": "Não foi possível carregar as condições clínicas.",
				"delete": "Não foi possível excluir a condição."
			}
		},
		"exams": {
			"loading": "Carregando exames",
			"close": "Fechar",
			"columns": {
				"requestedAt": "Solicitado em",
				"tests": "Exames solicitados",
				"clinic": "Clínica",
				"vet": "Veterinário",
				"status": "Status",
				"progress": "Progresso",
				"actions": "Ações"
			},
			"status": {
				"MISSING": "Pendente",
				"PENDING": "Pendente",
				"PARTIAL": "Parcial",
				"DONE": "Finalizado",
				"DOCUMENT": "Somente arquivo"
			},
			"empty": {
				"title": "Nenhum exame encontrado",
				"description": "Que tal colocar em dia os exames do seu pet?"
			},
			"actions": {
				"openAria": "Abrir exame",
				"deleteAria": "Excluir resultado",
				"deleteDisabledTooltip": "Resultados vinculados a consultas só podem ser alterados ou removidos na consulta."
			},
			"origin": {
				"manual": "Manual",
				"visit": "Consulta"
			},
			"filters": {
				"statusLabel": "Status",
				"statusPlaceholder": "Filtrar por status",
				"originLabel": "Origem",
				"originPlaceholder": "Manual ou consulta",
				"examLabel": "Exame / painel",
				"examPlaceholder": "Buscar por exame, painel ou item (ex.: Monócitos)"
			},
			"testsMore": "+ {count} exames",
			"testsMoreSingular": "+ {count} exame",
			"delete": {
				"title": "Excluir resultado de exame?",
				"content": "Esta ação não poderá ser desfeita.",
				"confirm": "Excluir",
				"cancel": "Cancelar",
				"success": "Resultado excluído.",
				"error": "Não foi possível excluir o resultado."
			},
			"fallback": {
				"exam": "Exame",
				"panel": "Pacote",
				"exams": "Exames",
				"request": "Solicitação",
				"noRef": "Sem referência",
				"noValue": "Sem valor",
				"inRange": "Na faixa",
				"low": "Baixo",
				"high": "Alto",
				"noRefShort": "Sem ref.",
				"improving": "Melhorando",
				"worsening": "Piorando",
				"stable": "Estável",
				"noBaseline": "Sem base"
			},
			"referenceDisclaimer": "Valores de referência são informativos e não substituem avaliação clínica nem diagnosticam por si só.",
			"details": {
				"tabs": {
					"aria": "Seções do resultado de exame",
					"info": "Solicitação",
					"values": "Valores",
					"documents": "Laudos"
				},
				"meta": {
					"saveError": "Não foi possível salvar os dados da solicitação."
				},
				"visit": {
					"consultation": "Data da solicitação",
					"clinic": "Clínica",
					"vet": "Veterinário"
				},
				"itemsCount": "itens",
				"columns": {
					"exam": "Exame",
					"reference": "Referência",
					"value": "Valor",
					"performed": "Realizado",
					"resulted": "Resultado",
					"actions": "Ações"
				},
				"edit": {
					"numeric": "Numérico",
					"text": "Texto",
					"refLow": "Mín.",
					"refHigh": "Máx.",
					"refText": "Ref. (texto)",
					"reportText": "Laudo / descrição",
					"conclusion": "Conclusão",
					"reportShort": "Laudo",
					"notPerformed": "Não realizado",
					"valueNumPlaceholder": "Informe o valor",
					"valueTextPlaceholder": "Informe o resultado",
					"resetReference": "Resetar referência"
				},
				"origin": {
					"visitHint": "Origem: consulta — campos somente leitura"
				},
				"status": {
					"label": "Status",
					"PENDING": "Pendente",
					"PARTIAL": "Parcial",
					"DONE": "Concluído"
				},
				"panelReport": {
					"title": "Laudo do painel"
				},
				"requestReport": {
					"title": "Laudo / resultado da solicitação"
				},
				"availability": {
					"NO_RESULT": "Sem resultado",
					"DOCUMENT_ONLY": "Só documental",
					"STRUCTURED": "Estruturado",
					"HYBRID": "Híbrido"
				},
				"documentOnlyEmpty": "Resultado anexado — sem dados estruturados para comparação.",
				"noStructuredItems": "Nenhum exame estruturado neste pedido.",
				"documents": {
					"title": "Arquivos anexados",
					"itemTitle": "Laudo do item",
					"upload": "Anexar laudo (PDF ou imagem)",
					"extractPdf": "Extrair do PDF",
					"empty": "Nenhum arquivo anexado neste resultado.",
					"openError": "Não foi possível abrir o arquivo.",
					"uploadHint": "Envie PDF ou imagem. Se o OCR reconhecer texto, sugerimos itens estruturados; caso contrário, o arquivo fica salvo no laudo."
				},
				"ocr": {
					"title": "Revisão da extração",
					"hint": "Confirme, edite ou ignore cada linha antes de aplicar no pedido.",
					"empty": "Nenhuma linha de exame encontrada no PDF (pode não ter camada de texto).",
					"warning": "Extração com avisos: {message}",
					"failed": "Falha na extração: {message}",
					"suggested": "Sugestão",
					"value": "Valor",
					"unit": "Unidade",
					"confirm": "Confirmar",
					"ignore": "Ignorar",
					"edit": "Editar",
					"apply": "Aplicar confirmados",
					"applying": "Aplicando…",
					"extracting": "Extraindo…",
					"status": {
						"PENDING": "Pendente",
						"CONFIRMED": "Confirmado",
						"EDITED": "Editado",
						"IGNORED": "Ignorado",
						"CUSTOM": "Custom"
					},
					"errors": {
						"extract": "Não foi possível extrair o PDF.",
						"apply": "Não foi possível aplicar a extração.",
						"patch": "Não foi possível atualizar a revisão."
					}
				},
				"addExam": "Adicionar exame",
				"addExamHintVisit": "Para incluir novos exames vinculados a consulta, altere a consulta.",
				"addExamPlaceholder": "Buscar exame ou painel…"
			},
			"compare": {
				"filters": {
					"examLabel": "Exame / painel",
					"examPlaceholder": "Buscar exame ou painel",
					"panelLabel": "Painel",
					"panelPlaceholder": "Filtrar por painel",
					"fromLabel": "De",
					"toLabel": "Até",
					"clear": "Limpar",
					"rangeLabel": "Faixa de referência",
					"rangePlaceholder": "Todas as faixas",
					"rangeIn": "Dentro da faixa",
					"rangeOut": "Fora da faixa (acima ou abaixo)",
					"rangeLow": "Abaixo da faixa",
					"rangeHigh": "Acima da faixa",
					"onlyRepeated": "Somente exames com mais de uma ocorrência"
				},
				"metrics": {
					"exams": "exames",
					"out": "fora",
					"inRange": "na faixa",
					"last": "último",
					"missingPartial": "{count} exames faltando registro",
					"neverRecorded": "{count} exames sem registro"
				},
				"empty": {
					"title": "Nenhum exame realizado",
					"description": "Aqui você verá a comparação dos valores dos exames para acompanhar a evolução do seu pet!"
				},
				"card": {
					"ref": "Ref:",
					"lastValue": "Último valor",
					"chartAria": "Evolução do exame",
					"noChartData": "Sem dados numéricos para gráfico.",
					"date": "Data",
					"value": "Valor",
					"panel": "Painel"
				},
				"errors": {
					"load": "Não foi possível carregar o comparativo."
				}
			},
			"errors": {
				"load": "Não foi possível carregar os exames."
			},
			"form": {
				"performedAt": "Data realizada",
				"veterinarian": "Veterinário",
				"veterinarianPlaceholder": "Selecione o veterinário",
				"vetName": "Nome do veterinário",
				"vetNamePlaceholder": "Nome",
				"vetCrmv": "CRMV",
				"vetCrmvPlaceholder": "CRMV",
				"clinic": "Clínica / laboratório",
				"clinicPlaceholder": "Selecione a clínica",
				"clinicName": "Nome da clínica",
				"clinicNamePlaceholder": "Nome",
				"notes": "Observações / método",
				"notesPlaceholder": "Método, laboratório, observações…",
				"examRequests": "Exames e painéis",
				"examRequestsPlaceholder": "Selecione exames ou painéis",
				"valuesTitle": "Valores",
				"valuesHint": "Preencha os valores agora ou depois nos detalhes. Cada valor é salvo individualmente.",
				"valueNum": "Valor numérico",
				"valueText": "Valor (texto)",
				"upload": "Anexos do resultado",
				"success": {
					"create": "Resultado de exame registrado.",
					"update": "Resultado de exame atualizado."
				},
				"errors": {
					"load": "Não foi possível carregar o formulário de exames.",
					"save": "Não foi possível salvar o resultado de exame.",
					"examsOrUpload": "Selecione ao menos um exame/painel ou anexe um arquivo."
				}
			}
		},
		"petAccess": {
			"title": "Acesso de veterinários",
			"loading": "Carregando acessos",
			"fallbackInvite": "Convite",
			"invite": {
				"title": "Convidar veterinário",
				"nameLabel": "Nome",
				"namePlaceholder": "Ex: Dra. Ana",
				"emailLabel": "E-mail",
				"emailPlaceholder": "email@exemplo.com",
				"submit": "Enviar convite",
				"hint": "O veterinário receberá um link para aceitar o acesso.",
				"sent": "Convite enviado.",
				"resent": "Convite reenviado."
			},
			"filters": {
				"searchLabel": "Busca",
				"searchPlaceholder": "Filtrar por nome ou e-mail",
				"kindLabel": "Tipo",
				"kindPlaceholder": "Qual",
				"kindAccess": "Acessos",
				"kindInvite": "Convites",
				"kindClearAria": "Limpar tipo",
				"statusLabel": "Status",
				"statusPlaceholder": "Status",
				"statusClearAria": "Limpar status",
				"onlyActiveAccess": "Exibir apenas acessos ativos"
			},
			"status": {
				"active": "Ativo",
				"blocked": "Bloqueado",
				"pending": "Pendente",
				"expired": "Expirado",
				"accepted": "Aceito",
				"revoked": "Cancelado",
				"vetRejected": "Recusado pelo veterinário"
			},
			"columns": {
				"name": "Nome",
				"kind": "Tipo",
				"email": "E-mail",
				"status": "Status",
				"actions": "Ações"
			},
			"empty": {
				"title": "Nenhum veterinário ou convite encontrado",
				"description": "Convide um veterinário para acompanhar a vida do seu pet."
			},
			"noResults": {
				"title": "Nenhum resultado encontrado",
				"description": "Tente ajustar os filtros para encontrar o que procura."
			},
			"actions": {
				"activateAria": "Ativar acesso",
				"blockAria": "Bloquear acesso",
				"unblockAria": "Desbloquear acesso",
				"removeAria": "Remover acesso",
				"cancelInviteAria": "Cancelar convite",
				"resendInviteAria": "Reenviar convite"
			},
			"modal": {
				"cancel": "Cancelar"
			},
			"revokeInvite": {
				"title": "Cancelar convite?",
				"contentWithEmail": "Tem certeza que deseja cancelar o convite para \"{email}\"?",
				"contentGeneric": "Tem certeza que deseja cancelar este convite?",
				"confirm": "Cancelar convite",
				"success": "Convite cancelado."
			},
			"removeAccess": {
				"title": "Remover acesso?",
				"contentWithName": "Tem certeza que deseja remover o acesso de \"{name}\"?",
				"contentGeneric": "Tem certeza que deseja remover este acesso?",
				"confirm": "Remover",
				"success": "Acesso removido."
			},
			"errors": {
				"load": "Não foi possível carregar os acessos.",
				"invite": "Não foi possível enviar o convite.",
				"inviteAlreadySent": "Esse pet já tem um convite pendente para esse e-mail.",
				"alreadyHasAccess": "Esse e-mail já tem acesso a este pet.",
				"resend": "Não foi possível reenviar o convite.",
				"updateStatus": "Não foi possível atualizar o acesso.",
				"revokeInvite": "Não foi possível cancelar o convite.",
				"removeAccess": "Não foi possível remover o acesso."
			}
		},
		"settings": {
			"shared": {
				"species": {
					"dog": "Cachorro",
					"cat": "Gato",
					"dog_cat": "Cachorro e Gato",
					"other": "Outro"
				},
				"sex": {
					"male": "Macho",
					"female": "Fêmea",
					"notDeclared": "Não informado"
				},
				"examKinds": {
					"BLOOD": "Sangue",
					"URINE": "Urina",
					"FECES": "Fezes",
					"IMAGE": "Imagem",
					"CYTOLOGY": "Citologia",
					"HISTOPATHOLOGY": "Histopatologia",
					"MICROBIOLOGY": "Microbiologia",
					"RAPID_TEST": "Teste rápido",
					"GENETIC": "Genético",
					"CARDIOLOGY": "Cardiológico",
					"OTHER": "Outro"
				},
				"fasting": {
					"NO": "Não",
					"YES": "Sim",
					"PREFERRED": "Preferencialmente sim",
					"NOT_APPLICABLE": "Não aplicável",
					"VARIABLE": "Variável",
					"NAO": "Não",
					"SIM": "Sim",
					"PREFERENCIALMENTE_SIM": "Preferencialmente sim"
				},
				"labSpecies": {
					"DOG": "Cão",
					"CAT": "Gato"
				},
				"labTestStatuses": {
					"DRAFT": "Rascunho",
					"ACTIVE": "Ativo",
					"INACTIVE": "Inativo",
					"DEPRECATED": "Depreciado"
				},
				"resultTypes": {
					"NUMERIC": "Numérico",
					"QUALITATIVE": "Qualitativo",
					"ORDINAL": "Ordinal",
					"BOOLEAN": "Booleano",
					"TEXT": "Texto",
					"REPORT": "Laudo",
					"COMPOSITE": "Composto",
					"UNSPECIFIED": "Não especificado"
				}
			},
			"vaccineTypes": {
				"close": "Fechar",
				"loading": "Carregando catálogo de vacinas",
				"tabs": {
					"aria": "Catálogo de vacinas",
					"kinds": "Tipos",
					"brands": "Marcas",
					"products": "Produtos",
					"others": "Outros"
				},
				"yes": "Sim",
				"no": "Não",
				"active": "Ativo",
				"inactive": "Inativo",
				"filters": {
					"showDeleted": "Exibir deletados"
				},
				"actions": {
					"delete": "Excluir",
					"deleteAria": "Excluir item do catálogo",
					"restore": "Restaurar",
					"restoreAria": "Restaurar item do catálogo",
					"cancel": "Cancelar"
				},
				"delete": {
					"title": "Excluir item do catálogo?",
					"content": "Isso vai marcar \"{name}\" como deletado. Ele deixará de aparecer nas listagens padrão.",
					"success": "Item excluído."
				},
				"restore": {
					"title": "Restaurar item do catálogo?",
					"content": "Isso vai restaurar \"{name}\" para as listagens padrão.",
					"success": "Item restaurado."
				},
				"errors": {
					"delete": "Não foi possível excluir o item.",
					"restore": "Não foi possível restaurar o item."
				},
				"kinds": {
					"loading": "Carregando tipos",
					"form": {
						"createTitle": "Cadastrar tipo de vacina",
						"editTitle": "Editar tipo de vacina",
						"codeLabel": "Código",
						"codePlaceholder": "Ex.: RABIES",
						"nameLabel": "Nome padrão",
						"boosterGroupLabel": "Grupo de reforço",
						"boosterGroupPlaceholder": "Selecione o grupo",
						"boosterGroupOther": "Outro (informar código)",
						"boosterGroupOtherCodeLabel": "Código do grupo",
						"boosterGroupOtherCodePlaceholder": "Ex.: canine-polyvalent",
						"speciesLabel": "Espécies",
						"diseasesLabel": "Doenças cobertas",
						"diseasesPlaceholder": "Selecione as doenças",
						"diseasesEmpty": "Nenhuma doença encontrada",
						"isOtherLabel": "Tipo \"Outra\"",
						"alertsEnabledLabel": "Gerar alertas de reforço",
						"activeLabel": "Ativo",
						"descriptionLabel": "Descrição",
						"descriptionPlaceholder": "Escreva a descrição",
						"save": "Salvar",
						"cancel": "Cancelar"
					},
					"filters": {
						"nameLabel": "Busca",
						"namePlaceholder": "Código ou nome",
						"speciesLabel": "Espécie",
						"speciesPlaceholder": "Espécie",
						"speciesClearAria": "Limpar espécie"
					},
					"columns": {
						"code": "Código",
						"name": "Nome",
						"boosterGroup": "Grupo de reforço",
						"species": "Espécies",
						"diseases": "Doenças",
						"isOther": "Outra",
						"active": "Ativo",
						"actions": "Ações"
					},
					"empty": {
						"title": "Nenhum tipo cadastrado",
						"description": "Cadastre os tipos de vacina do sistema."
					},
					"noResults": {
						"title": "Nenhum tipo encontrado",
						"description": "Tente ajustar os filtros para encontrar o que procura."
					},
					"actions": {
						"editAria": "Editar tipo"
					},
					"errors": {
						"load": "Não foi possível carregar os tipos de vacina.",
						"save": "Não foi possível salvar o tipo de vacina.",
						"speciesRequired": "Selecione ao menos uma espécie.",
						"boosterGroupRequired": "Informe o grupo de reforço."
					},
					"boosterGroups": {
						"canine-polyvalent": "Polivalente canina",
						"feline-polyvalent": "Polivalente felina"
					}
				},
				"brands": {
					"loading": "Carregando marcas",
					"form": {
						"createTitle": "Cadastrar marca",
						"editTitle": "Editar marca",
						"nameLabel": "Nome",
						"activeLabel": "Ativa",
						"save": "Salvar",
						"cancel": "Cancelar"
					},
					"filters": {
						"nameLabel": "Busca",
						"namePlaceholder": "Nome da marca"
					},
					"columns": {
						"name": "Nome",
						"active": "Ativa",
						"actions": "Ações"
					},
					"empty": {
						"title": "Nenhuma marca cadastrada",
						"description": "Cadastre as marcas comerciais de vacinas."
					},
					"noResults": {
						"title": "Nenhuma marca encontrada",
						"description": "Tente ajustar os filtros para encontrar o que procura."
					},
					"actions": {
						"editAria": "Editar marca"
					},
					"errors": {
						"load": "Não foi possível carregar as marcas.",
						"save": "Não foi possível salvar a marca."
					}
				},
				"products": {
					"loading": "Carregando produtos",
					"form": {
						"createTitle": "Cadastrar produto",
						"editTitle": "Editar produto",
						"kindLabel": "Tipo",
						"kindPlaceholder": "Selecione o tipo",
						"brandLabel": "Marca",
						"brandPlaceholder": "Selecione a marca",
						"nameLabel": "Nome comercial",
						"speciesLabel": "Espécies",
						"isOtherLabel": "Produto \"Outro\"",
						"activeLabel": "Ativo",
						"notesLabel": "Observações",
						"notesPlaceholder": "Escreva observações",
						"save": "Salvar",
						"cancel": "Cancelar"
					},
					"filters": {
						"nameLabel": "Busca",
						"namePlaceholder": "Nome comercial",
						"kindLabel": "Tipo",
						"kindPlaceholder": "Tipo",
						"kindClearAria": "Limpar tipo",
						"speciesLabel": "Espécie",
						"speciesPlaceholder": "Espécie",
						"speciesClearAria": "Limpar espécie"
					},
					"columns": {
						"name": "Nome comercial",
						"kind": "Tipo",
						"brand": "Marca",
						"species": "Espécies",
						"isOther": "Outro",
						"active": "Ativo",
						"actions": "Ações"
					},
					"empty": {
						"title": "Nenhum produto cadastrado",
						"description": "Cadastre os produtos comerciais de vacinas."
					},
					"noResults": {
						"title": "Nenhum produto encontrado",
						"description": "Tente ajustar os filtros para encontrar o que procura."
					},
					"actions": {
						"editAria": "Editar produto"
					},
					"errors": {
						"load": "Não foi possível carregar os produtos.",
						"save": "Não foi possível salvar o produto.",
						"speciesRequired": "Selecione ao menos uma espécie."
					}
				},
				"others": {
					"loading": "Carregando fila de outros",
					"filters": {
						"statusLabel": "Status"
					},
					"status": {
						"open": "Abertos",
						"promoted": "Promovidos",
						"dismissed": "Descartados",
						"all": "Todos"
					},
					"columns": {
						"type": "Tipo",
						"rawText": "Texto",
						"applicationCount": "Ocorrências",
						"actions": "Ações"
					},
					"typeKind": "Tipo de vacina",
					"typeProduct": "Produto",
					"actions": {
						"promote": "Promover",
						"dismiss": "Descartar"
					},
					"form": {
						"codeLabel": "Código",
						"nameLabel": "Nome padrão",
						"commercialNameLabel": "Nome comercial",
						"kindLabel": "Tipo de vacina",
						"kindPlaceholder": "Selecione o tipo",
						"speciesLabel": "Espécies",
						"cancel": "Cancelar",
						"confirmPromote": "Confirmar"
					},
					"empty": {
						"title": "Nenhum item na fila",
						"description": "Textos livres de vacina aparecerão aqui para revisão."
					},
					"noResults": {
						"title": "Nenhum item encontrado",
						"description": "Tente ajustar o filtro de status."
					},
					"errors": {
						"load": "Não foi possível carregar a fila de outros.",
						"dismiss": "Não foi possível descartar o item.",
						"promote": "Não foi possível promover o item.",
						"speciesRequired": "Selecione ao menos uma espécie.",
						"kindRequired": "Selecione o tipo de vacina."
					}
				}
			},
			"diseases": {
				"close": "Fechar",
				"loading": "Carregando doenças",
				"form": {
					"createTitle": "Cadastrar doença",
					"editTitle": "Editar doença",
					"codeLabel": "Código",
					"codePlaceholder": "Ex.: RABIES",
					"nameLabel": "Nome padrão",
					"activeLabel": "Ativa",
					"save": "Salvar",
					"cancel": "Cancelar"
				},
				"filters": {
					"nameLabel": "Busca",
					"namePlaceholder": "Código ou nome",
					"showDeleted": "Exibir deletadas"
				},
				"columns": {
					"code": "Código",
					"name": "Nome",
					"active": "Ativa",
					"actions": "Ações"
				},
				"empty": {
					"title": "Nenhuma doença cadastrada",
					"description": "Cadastre doenças para vincular a vacinas, diagnósticos e condições."
				},
				"noResults": {
					"title": "Nenhuma doença encontrada",
					"description": "Tente ajustar os filtros para encontrar o que procura."
				},
				"actions": {
					"editAria": "Editar doença",
					"delete": "Excluir",
					"deleteAria": "Excluir doença",
					"restore": "Restaurar",
					"restoreAria": "Restaurar doença",
					"cancel": "Cancelar"
				},
				"delete": {
					"title": "Excluir doença?",
					"content": "Isso vai marcar \"{name}\" como deletada.",
					"success": "Doença excluída."
				},
				"restore": {
					"title": "Restaurar doença?",
					"content": "Isso vai restaurar \"{name}\".",
					"success": "Doença restaurada."
				},
				"errors": {
					"load": "Não foi possível carregar as doenças.",
					"save": "Não foi possível salvar a doença.",
					"delete": "Não foi possível excluir a doença.",
					"restore": "Não foi possível restaurar a doença."
				}
			},
			"breeds": {
				"title": "Raças e pelagem",
				"subtitle": "Consulte as raças, gerencie cores de pelagem e revise textos livres informados como \"Outro\"",
				"close": "Fechar alerta",
				"tabs": {
					"aria": "Seções de raças",
					"catalog": "Raças",
					"reference": "Pelagem",
					"others": "Outros"
				},
				"catalog": {
					"loading": "Carregando raças",
					"filters": {
						"species": "Espécie",
						"search": "Busca",
						"searchPlaceholder": "Nome ou código"
					},
					"columns": {
						"code": "Código",
						"name": "Nome",
						"group": "Grupo"
					},
					"empty": {
						"title": "Nenhuma raça encontrada",
						"description": "Ajuste os filtros ou selecione outra espécie."
					},
					"noResults": {
						"title": "Nenhum resultado",
						"description": "Nenhuma raça corresponde aos filtros atuais."
					},
					"errors": {
						"load": "Não foi possível carregar as raças.",
						"save": "Não foi possível salvar a raça.",
						"codeExists": "Já existe uma raça com este código para a espécie."
					},
					"saveSuccess": "Raça cadastrada com sucesso.",
					"form": {
						"createTitle": "Cadastrar raça",
						"speciesLabel": "Espécie",
						"codeLabel": "Código",
						"codePlaceholder": "ex.: LABRADOR",
						"nameLabel": "Nome",
						"namePlaceholder": "Nome exibido",
						"save": "Salvar"
					}
				},
				"colors": {
					"loading": "Carregando cores",
					"filterTipo": "cores",
					"saveSuccess": "Cor salva com sucesso.",
					"deleteSuccess": "Cor removida com sucesso.",
					"restoreSuccess": "Cor restaurada com sucesso.",
					"filters": {
						"search": "Busca",
						"searchPlaceholder": "Nome ou código",
						"showDeleted": "Mostrar removidas"
					},
					"form": {
						"createTitle": "Cadastrar nova cor",
						"editTitle": "Editar cor",
						"codeLabel": "Código",
						"codePlaceholder": "ex.: merle",
						"nameLabel": "Nome",
						"namePlaceholder": "Nome exibido",
						"sortOrderLabel": "Ordem",
						"activeLabel": "Ativa",
						"save": "Salvar",
						"cancel": "Cancelar"
					},
					"columns": {
						"code": "Código",
						"name": "Nome",
						"sortOrder": "Ordem",
						"active": "Ativa",
						"actions": "Ações"
					},
					"actions": {
						"editAria": "Editar cor",
						"deleteAria": "Remover cor",
						"restoreAria": "Restaurar cor",
						"delete": "Remover",
						"restore": "Restaurar",
						"cancel": "Cancelar"
					},
					"delete": {
						"title": "Remover cor",
						"content": "Remover a cor \"{{name}}\"? Pets que já usam esta cor mantêm o valor salvo."
					},
					"restore": {
						"title": "Restaurar cor",
						"content": "Restaurar a cor \"{{name}}\"?"
					},
					"empty": {
						"title": "Nenhuma cor cadastrada",
						"description": "Cadastre a primeira cor de pelagem."
					},
					"noResults": {
						"title": "Nenhum resultado",
						"description": "Nenhuma cor corresponde aos filtros atuais."
					},
					"errors": {
						"load": "Não foi possível carregar as cores.",
						"save": "Não foi possível salvar a cor.",
						"delete": "Não foi possível remover a cor.",
						"restore": "Não foi possível restaurar a cor."
					}
				},
				"others": {
					"loading": "Carregando fila de revisão",
					"filters": {
						"species": "Espécie",
						"status": "Status",
						"allSpecies": "Todas as espécies"
					},
					"columns": {
						"text": "Texto informado",
						"species": "Espécie",
						"pets": "Pets",
						"status": "Status",
						"actions": "Ações"
					},
					"status": {
						"open": "Aberto",
						"promoted": "Promovido",
						"dismissed": "Descartado",
						"all": "Todos"
					},
					"actions": {
						"promote": "Promover",
						"dismiss": "Descartar"
					},
					"promote": {
						"code": "Código",
						"name": "Nome",
						"species": "Espécie",
						"create": "Criar raça",
						"linkExisting": "Vincular a raça existente",
						"link": "Vincular",
						"cancel": "Cancelar"
					},
					"empty": {
						"title": "Nenhum item na fila",
						"description": "Textos livres informados como \"Outro\" aparecerão aqui para revisão."
					},
					"noResults": {
						"title": "Nenhum resultado",
						"description": "Nenhum item corresponde aos filtros atuais."
					},
					"promoteSuccess": "Raça promovida com sucesso.",
					"dismissSuccess": "Item descartado.",
					"errors": {
						"load": "Não foi possível carregar a fila de revisão.",
						"promote": "Não foi possível promover este item.",
						"dismiss": "Não foi possível descartar este item."
					}
				}
			},
			"examTypes": {
				"close": "Fechar",
				"loading": "Carregando tipos de exame",
				"disclaimer": "Valores de referência são informativos e não substituem avaliação clínica nem diagnosticam por si só.",
				"form": {
					"createTitle": "Cadastrar tipo de exame",
					"editTitle": "Editar tipo de exame",
					"nameLabel": "Nome conhecido",
					"namePlaceholder": "Ex.: Glicose, SDMA, TGP/ALT",
					"officialNameLabel": "Nome oficial",
					"officialNamePlaceholder": "Ex.: Glicose sérica",
					"codeLabel": "Código",
					"codePlaceholder": "Ex.: GLU-SER",
					"categoryLabel": "Categoria (texto legado)",
					"categoryIdLabel": "Categoria",
					"categoryIdPlaceholder": "Selecione a categoria",
					"subcategoryIdLabel": "Subcategoria",
					"subcategoryIdPlaceholder": "Selecione a subcategoria",
					"speciesLabel": "Espécie",
					"speciesPlaceholder": "Espécie",
					"speciesCodesLabel": "Espécies aplicáveis",
					"speciesRequiredError": "Selecione ao menos uma espécie.",
					"examKindLabel": "Tipo de exame",
					"examKindPlaceholder": "Tipo de exame",
					"statusLabel": "Status",
					"resultTypeLabel": "Tipo de resultado",
					"aliasesLabel": "Aliases / sinônimos",
					"aliasesPlaceholder": "Separe por vírgula",
					"tagsLabel": "Tags",
					"tagsPlaceholder": "Separe por vírgula",
					"resultOptionsLabel": "Opções qualitativas",
					"resultOptionsPlaceholder": "Ex.: Negativo, Positivo, Indeterminado",
					"replacementLabel": "Exame substituto (depreciado)",
					"replacementPlaceholder": "Selecione o exame canônico",
					"unitLabel": "Unidade",
					"refDogTitle": "Referência — cão",
					"refCatTitle": "Referência — gato",
					"refLowLabel": "Mínima",
					"refHighLabel": "Máxima",
					"refTextLabel": "Texto de referência",
					"refNotesLabel": "Notas da referência",
					"fastingRequiredLabel": "Tem jejum?",
					"fastingRequiredPlaceholder": "Jejum",
					"fastingTimeLabel": "Tempo de jejum",
					"fastingTimePlaceholder": "Ex.: 8 a 12 horas",
					"fastingMinLabel": "Jejum mínimo (min)",
					"fastingMaxLabel": "Jejum máximo (min)",
					"descriptionLabel": "Descrição",
					"descriptionPlaceholder": "Descrição técnica do exame",
					"preparationInformationLabel": "Informações de preparo",
					"preparationInformationPlaceholder": "Orientações de preparo do paciente",
					"additionalInfoLabel": "Informações do catálogo",
					"additionalInfoPlaceholder": "Orientações, observações para o catálogo...",
					"reviewRequiredLabel": "Exige revisão",
					"routineLabel": "Rotina",
					"sortOrderLabel": "Ordem de exibição",
					"save": "Salvar",
					"cancel": "Cancelar",
					"softDelete": "Excluir (desativar)",
					"deactivate": "Excluir (desativar)",
					"saveSuccess": "Tipo de exame salvo com sucesso.",
					"updateSuccess": "Tipo de exame atualizado com sucesso.",
					"softDeleteSuccess": "Tipo de exame excluído (desativado).",
					"deactivateSuccess": "Tipo de exame excluído (desativado)."
				},
				"filters": {
					"nameLabel": "Nome exame",
					"namePlaceholder": "Nome (conhecido ou oficial)",
					"speciesLabel": "Espécie",
					"speciesPlaceholder": "Espécie",
					"speciesClearAria": "Limpar espécie",
					"examKindLabel": "Tipo de exame",
					"statusLabel": "Status",
					"includeInactive": "Incluir inativos",
					"includeDeprecated": "Incluir depreciados"
				},
				"columns": {
					"name": "Nome",
					"officialName": "Nome oficial",
					"status": "Status",
					"species": "Espécie",
					"examKind": "Tipo de exame",
					"unit": "Unidade",
					"reference": "Referência",
					"category": "Categoria",
					"additionalInfo": "Infos adicionais",
					"actions": "Ações"
				},
				"empty": {
					"title": "Nenhum tipo de exame cadastrado",
					"description": "Cadastre e permita que os exames sejam encontrados no sistema."
				},
				"noResults": {
					"title": "Nenhum tipo de exame encontrado",
					"description": "Tente ajustar os filtros para encontrar o que procura."
				},
				"actions": {
					"editAria": "Editar tipo de exame",
					"duplicateAria": "Duplicar tipo de exame",
					"softDeleteAria": "Excluir tipo de exame"
				},
				"errors": {
					"load": "Não foi possível carregar os tipos de exame.",
					"save": "Não foi possível salvar o tipo de exame.",
					"softDelete": "Não foi possível excluir o tipo de exame.",
					"deactivate": "Não foi possível excluir o tipo de exame."
				}
			},
			"examPanels": {
				"close": "Fechar",
				"loading": "Carregando pacotes de exame",
				"form": {
					"createTitle": "Cadastrar pacote de exame",
					"editTitle": "Editar pacote de exame",
					"nameLabel": "Nome do pacote",
					"officialNameLabel": "Nome oficial",
					"officialNamePlaceholder": "Nome oficial do pacote",
					"codeLabel": "Código",
					"codePlaceholder": "Ex.: PANEL-BIOQ",
					"statusLabel": "Status",
					"speciesLabel": "Espécie (legado)",
					"speciesPlaceholder": "Espécie",
					"speciesCodesLabel": "Espécies aplicáveis",
					"speciesRequiredError": "Selecione ao menos uma espécie.",
					"examKindLabel": "Tipo de exame",
					"examKindPlaceholder": "Tipo de exame",
					"categoryIdLabel": "Categoria",
					"categoryIdPlaceholder": "Selecione a categoria",
					"fastingRequiredLabel": "Tem jejum?",
					"fastingRequiredPlaceholder": "Jejum",
					"fastingTimeLabel": "Tempo de jejum",
					"fastingTimePlaceholder": "Ex.: 8 a 12 horas",
					"fastingMinLabel": "Jejum mínimo (min)",
					"fastingMaxLabel": "Jejum máximo (min)",
					"descriptionLabel": "Descrição",
					"descriptionPlaceholder": "Descrição do pacote",
					"reviewRequiredLabel": "Exige revisão",
					"sortOrderLabel": "Ordem de exibição",
					"itemsTitle": "Exames que fazem parte do pacote",
					"itemTypeLabel": "Tipo de exame",
					"itemTypePlaceholder": "Selecionar tipo de exame",
					"itemTypeEmpty": "Nenhum tipo de exame disponível",
					"itemRequiredLabel": "Obrigatório",
					"itemDefaultLabel": "Selecionado por padrão",
					"addItem": "Adicionar ao pacote",
					"itemsEmpty": "Nenhum exame adicionado ao pacote.",
					"tagRequired": "Obrigatório",
					"tagDefault": "Selecionado por padrão",
					"saveSuccess": "Pacote de exame salvo com sucesso.",
					"updateSuccess": "Pacote de exame atualizado com sucesso.",
					"softDelete": "Excluir (desativar)",
					"softDeleteSuccess": "Pacote de exame excluído (desativado).",
					"removeItem": "Remover",
					"moveItemUp": "Mover exame para cima",
					"moveItemDown": "Mover exame para baixo",
					"save": "Salvar",
					"cancel": "Cancelar"
				},
				"filters": {
					"nameLabel": "Nome do pacote",
					"namePlaceholder": "Nome do pacote",
					"speciesLabel": "Espécie",
					"speciesPlaceholder": "Espécie",
					"speciesClearAria": "Limpar espécie",
					"examKindLabel": "Tipo de exame",
					"examKindPlaceholder": "Tipo de exame",
					"examKindClearAria": "Limpar tipo de exame",
					"statusLabel": "Status",
					"includeInactive": "Incluir inativos",
					"includeDeprecated": "Incluir depreciados"
				},
				"columns": {
					"name": "Nome",
					"species": "Espécie",
					"examKind": "Tipo de exame",
					"status": "Status",
					"itemsCount": "Qtd. de exames",
					"description": "Descrição",
					"actions": "Ações"
				},
				"empty": {
					"title": "Nenhum pacote de exame cadastrado",
					"description": "Cadastre e permita que os exames sejam encontrados no sistema."
				},
				"noResults": {
					"title": "Nenhum pacote encontrado",
					"description": "Tente ajustar os filtros para encontrar o que procura."
				},
				"actions": {
					"editAria": "Editar pacote de exame",
					"softDeleteAria": "Excluir pacote de exame"
				},
				"errors": {
					"load": "Não foi possível carregar os pacotes de exame.",
					"save": "Não foi possível salvar o pacote de exame.",
					"softDelete": "Não foi possível excluir o pacote de exame."
				}
			},
			"exams": {
				"tabs": {
					"aria": "Seções de administração de exames",
					"catalog": "Catálogo",
					"panels": "Painéis",
					"audit": "Auditoria",
					"imports": "Importações",
					"auditComingSoon": "A auditoria de exames estará disponível na próxima etapa.",
					"importsComingSoon": "As importações de planilha/PDF estarão disponíveis em etapas futuras."
				},
				"audit": {
					"disclaimer": "Revise exames cadastrados como “Outro” pelos tutores. Criar ou mesclar promove ao catálogo oficial e religa os pedidos; rejeitar mantém o texto original sem promover.",
					"loading": "Carregando fila de auditoria",
					"createSuccess": "Tipo oficial criado e entrada resolvida.",
					"mergeSuccess": "Entrada mesclada ao tipo oficial.",
					"rejectSuccess": "Entrada rejeitada.",
					"reopenSuccess": "Entrada reaberta para revisão.",
					"mergeTargetAria": "Tipo oficial para mesclar",
					"mergeTargetPlaceholder": "Buscar exame oficial…",
					"mergeTargetEmpty": "Nenhum exame encontrado",
					"filters": {
						"status": "Status",
						"q": "Busca",
						"qPlaceholder": "Nome original"
					},
					"columns": {
						"name": "Nome original",
						"status": "Status",
						"kind": "Tipo sugerido",
						"official": "Oficial",
						"updatedAt": "Atualizado",
						"actions": "Ações"
					},
					"actions": {
						"create": "Criar oficial",
						"merge": "Mesclar",
						"reject": "Rejeitar",
						"reopen": "Reabrir"
					},
					"status": {
						"pending": "Pendente",
						"created": "Criado",
						"merged": "Mesclado",
						"rejected": "Rejeitado",
						"all": "Todos"
					},
					"empty": {
						"title": "Nenhuma entrada",
						"description": "Quando tutores pedirem exames fora do catálogo, eles aparecerão aqui."
					},
					"errors": {
						"load": "Não foi possível carregar a auditoria.",
						"create": "Não foi possível criar o tipo oficial.",
						"merge": "Não foi possível mesclar a entrada.",
						"mergeTarget": "Informe o ID do tipo oficial para mesclar.",
						"reject": "Não foi possível rejeitar a entrada.",
						"reopen": "Não foi possível reabrir a entrada."
					}
				},
				"imports": {
					"disclaimer": "Importe o catálogo em CSV ou JSON, revise as classificações e aplique as ações por linha. O template v1 não inclui XLSX.",
					"loading": "Carregando importações",
					"uploadSuccess": "Arquivo enviado e classificado com sucesso.",
					"actionsSaved": "Ações das linhas salvas.",
					"applySuccess": "Importação aplicada com sucesso.",
					"emptyRows": "Nenhuma linha nesta importação.",
					"columns": {
						"filename": "Arquivo",
						"status": "Status",
						"totals": "Resumo",
						"createdAt": "Criado em",
						"actions": "Ações"
					},
					"actions": {
						"downloadTemplate": "Baixar template",
						"upload": "Enviar arquivo",
						"saveRows": "Salvar ações",
						"apply": "Aplicar importação",
						"openAria": "Abrir detalhe da importação",
						"create": "Criar",
						"update": "Atualizar",
						"ignore": "Ignorar",
						"link": "Vincular"
					},
					"status": {
						"readyForReview": "Pronto para revisão",
						"processing": "Processando",
						"applied": "Aplicado",
						"failed": "Falhou",
						"cancelled": "Cancelado"
					},
					"classification": {
						"new": "Novo",
						"identical": "Idêntico",
						"different": "Diferente",
						"possibleDuplicate": "Possível duplicata",
						"invalid": "Inválido"
					},
					"hints": {
						"create": "Sugestão: criar no catálogo",
						"update": "Sugestão: atualizar o exame correspondente",
						"link": "Sugestão: vincular / revisar duplicata",
						"ignore": "Sugestão: ignorar"
					},
					"compare": {
						"matched": "Corresponde a",
						"field": "Campo",
						"incoming": "Importado",
						"catalog": "Catálogo atual",
						"fields": {
							"code": "Código",
							"name": "Nome",
							"officialName": "Nome oficial",
							"examKind": "Tipo",
							"status": "Status",
							"resultType": "Tipo de resultado",
							"unit": "Unidade",
							"refLow": "Ref. mínima",
							"refHigh": "Ref. máxima",
							"category": "Categoria",
							"fastingRequirement": "Jejum",
							"description": "Descrição",
							"additionalInfo": "Info adicional",
							"species": "Espécies"
						}
					},
					"empty": {
						"title": "Nenhuma importação",
						"description": "Baixe o template e envie um CSV ou JSON para começar."
					},
					"errors": {
						"load": "Não foi possível carregar as importações.",
						"template": "Não foi possível baixar o template.",
						"upload": "Não foi possível enviar o arquivo.",
						"detail": "Não foi possível abrir o detalhe da importação.",
						"saveRows": "Não foi possível salvar as ações das linhas.",
						"apply": "Não foi possível aplicar a importação."
					},
					"actionHelp": {
						"createHelp": "Cria um novo exame no catálogo com os dados da coluna Importado.",
						"updateHelp": "Substitui os dados do exame correspondente no catálogo pelos valores Importados.",
						"ignoreHelp": "Não altera o catálogo; a linha importada é descartada.",
						"linkHelp": "Ainda não implementado de fato (hoje se comporta como Ignorar). Diga como quer que funcione."
					}
				}
			},
			"systemUsers": {
				"loading": "Carregando usuários",
				"filters": {
					"searchLabel": "Buscar",
					"searchPlaceholder": "Nome, e-mail, telefone",
					"roleLabel": "Tipo",
					"rolePlaceholder": "Todos",
					"roleClearAria": "Limpar tipo",
					"showDeleted": "Exibir deletados"
				},
				"roles": {
					"user": "Tutor",
					"vet": "Veterinário",
					"master": "Master"
				},
				"status": {
					"active": "Ativo",
					"pendingVerification": "Aguardando verificação",
					"blocked": "Bloqueado",
					"deleted": "Excluído"
				},
				"columns": {
					"name": "Nome",
					"email": "E-mail",
					"role": "Tipo",
					"pets": "Pets",
					"status": "Status",
					"createdAt": "Criado",
					"actions": "Ações"
				},
				"empty": {
					"title": "Nenhum usuário cadastrado",
					"description": "Em breve teremos usuários no sistema! :)"
				},
				"noResults": {
					"title": "Nenhum usuário encontrado",
					"description": "Tente ajustar os filtros para encontrar o que procura."
				},
				"actions": {
					"restoreAria": "Restaurar usuário",
					"deleteForeverAria": "Excluir definitivamente",
					"blockAria": "Bloquear usuário",
					"unblockAria": "Desbloquear usuário",
					"deleteAria": "Excluir usuário",
					"resendVerificationAria": "Reenviar e-mail de verificação"
				},
				"modal": {
					"cancel": "Cancelar"
				},
				"delete": {
					"title": "Excluir usuário",
					"content": "Isso vai marcar o usuário como excluído e desativar os pets dele (soft delete). Deseja continuar?\n\n{name}\n{email}",
					"confirm": "Excluir"
				},
				"deleteForever": {
					"title": "Excluir definitivamente",
					"content": "Essa ação é permanente e remove o usuário do banco. Só use se tiver certeza.\n\n{name}\n{email}",
					"confirm": "Excluir definitivamente"
				},
				"restore": {
					"title": "Restaurar usuário",
					"content": "Isso vai restaurar o usuário e os pets desativados junto com a exclusão. Deseja continuar?\n\n{name}\n{email}",
					"confirm": "Restaurar"
				},
				"success": {
					"resendVerification": "E-mail de verificação reenviado."
				},
				"errors": {
					"load": "Não foi possível carregar os usuários.",
					"updateStatus": "Não foi possível atualizar o status do usuário.",
					"delete": "Não foi possível excluir o usuário.",
					"deleteForever": "Não foi possível excluir definitivamente o usuário.",
					"restore": "Não foi possível restaurar o usuário.",
					"resendVerification": "Não foi possível reenviar o e-mail de verificação."
				}
			},
			"audit": {
				"loading": "Carregando auditoria",
				"filters": {
					"sourceLabel": "Origem",
					"sourceAuth": "Autenticação",
					"sourceActions": "Ações administrativas",
					"emailLabel": "E-mail",
					"emailPlaceholder": "Filtrar por e-mail",
					"eventLabel": "Evento",
					"eventPlaceholder": "Filtrar por evento",
					"actionLabel": "Ação",
					"actionPlaceholder": "Filtrar por ação",
					"entityTypeLabel": "Tipo de entidade",
					"entityTypePlaceholder": "Filtrar por tipo de entidade"
				},
				"columns": {
					"event": "Evento",
					"email": "E-mail",
					"userId": "Usuário",
					"action": "Ação",
					"entityType": "Tipo",
					"entityId": "ID da entidade",
					"entityName": "Entidade",
					"actorUserId": "ID do ator",
					"actorName": "Ator",
					"ip": "IP",
					"country": "País",
					"createdAt": "Data",
					"actions": "Ações"
				},
				"empty": {
					"title": "Nenhum registro de auditoria",
					"description": "Os logs de autenticação e ações administrativas aparecerão aqui."
				},
				"noResults": {
					"title": "Nenhum registro encontrado",
					"description": "Tente ajustar os filtros para encontrar o que procura."
				},
				"actions": {
					"metadataAria": "Ver metadados"
				},
				"metadata": {
					"title": "Metadados",
					"close": "Fechar"
				},
				"errors": {
					"load": "Não foi possível carregar os registros de auditoria."
				}
			},
			"dashboard": {
				"close": "Fechar",
				"loading": "Carregando dashboard",
				"refreshing": "Atualizando dados…",
				"tabs": {
					"aria": "Abas do dashboard admin",
					"pets": "Pets",
					"vaccines": "Vacinas",
					"exams": "Exames",
					"others": "Outros"
				},
				"period": {
					"from": "De",
					"to": "Até",
					"apply": "Aplicar",
					"petsHint": "Filtra pelo período de cadastro do pet e pelo tutor. A busca atualiza automaticamente.",
					"vaccinesHint": "Filtra pelo período em que a vacina foi aplicada. A busca atualiza automaticamente.",
					"examsHint": "Filtra exames realizados pela data do resultado (resulted_at / performed_at). A busca atualiza automaticamente."
				},
				"stats": {
					"petsTotal": "Total de pets",
					"petsActive": "Pets ativos",
					"withMicrochip": "Com microchip",
					"withoutMicrochip": "Sem microchip",
					"weighedRecent": "Pesados nos últimos 6 meses",
					"weighedStale": "Sem pesagem há +6 meses",
					"neverWeighed": "Nunca pesados",
					"applicationsTotal": "Aplicações",
					"petsVaccinated": "Pets vacinados",
					"resultsTotal": "Exames realizados",
					"petsWithResults": "Pets com exames",
					"panelResultsTotal": "Itens de painéis",
					"typeResultsTotal": "Exames avulsos"
				},
				"filters": {
					"title": "Filtros",
					"tutor": "Tutor",
					"allTutors": "Todo o sistema",
					"species": "Espécie",
					"allSpecies": "Todas as espécies",
					"examKind": "Tipo de exame",
					"allExamKinds": "Todos os tipos",
					"category": "Categoria",
					"allCategories": "Todas as categorias",
					"petSearch": "Buscar pet",
					"petSearchPlaceholder": "Nome do pet"
				},
				"charts": {
					"bySpecies": "Por espécie",
					"byAge": "Por faixa etária",
					"byGender": "Por sexo",
					"byBreed": "Por raça",
					"byBreedEmpty": "Nenhum pet com raça cadastrada no filtro atual.",
					"byWeightStatus": "Por status de pesagem",
					"byWeightStatusEmpty": "Sem dados de pesagem no filtro atual.",
					"byCreatedMonth": "Cadastros por mês",
					"byPetSpecies": "Pets vacinados por espécie",
					"examsByPetSpecies": "Pets com exames por espécie",
					"byMonth": "Aplicações por mês",
					"resultsByMonth": "Exames realizados por mês",
					"resultsByMonthEmpty": "Nenhum exame realizado no período filtrado.",
					"byKind": "Por tipo de vacina",
					"byExamKind": "Por tipo de exame (exam kind)",
					"byExamCategory": "Por categoria do catálogo",
					"byExamCategoryEmpty": "Nenhuma categoria disponível no filtro atual.",
					"byContext": "Por contexto da aplicação",
					"byLocationType": "Por tipo de local",
					"applicationsSeries": "Aplicações",
					"resultsSeries": "Exames realizados",
					"registrationsSeries": "Cadastros",
					"axis": {
						"species": "Espécie",
						"gender": "Sexo",
						"breed": "Raça",
						"month": "Mês",
						"kind": "Tipo de vacina",
						"examKind": "Tipo de exame",
						"category": "Categoria",
						"context": "Contexto",
						"locationType": "Tipo de local",
						"count": "Quantidade"
					}
				},
				"petsTable": {
					"title": "Pets com exames realizados",
					"subtitle": "{{total}} pet(s) no filtro atual",
					"emptyTitle": "Nenhum pet encontrado",
					"empty": "Não há pets com exames realizados para os filtros selecionados.",
					"openExams": "Abrir exames",
					"prev": "Anterior",
					"next": "Próxima",
					"page": "Página {{page}} de {{total}}",
					"columns": {
						"pet": "Pet",
						"species": "Espécie",
						"results": "Resultados",
						"lastResult": "Último resultado",
						"actions": "Ações"
					}
				},
				"age": {
					"puppy": "Filhote",
					"adult": "Adulto",
					"senior": "Sênior",
					"unknown": "Desconhecido",
					"hint": "Definição das faixas etárias:",
					"puppyHint": "Filhote: até 11 meses",
					"adultHint": "Adulto: de 1 ano até 6 anos e 11 meses",
					"seniorHint": "Sênior: 7 anos ou mais",
					"unknownHint": "Desconhecido: sem data de nascimento"
				},
				"labels": {
					"unknown": "Não informado"
				},
				"others": {
					"empty": "Nenhum item na fila",
					"emptyTitle": "Fila em dia",
					"openFullQueue": "Abrir fila completa",
					"promoteSuccess": "Item promovido com sucesso.",
					"dismissSuccess": "Item descartado com sucesso.",
					"applications": "Aplicações",
					"typeKind": "Tipo",
					"typeProduct": "Produto",
					"dismiss": "Descartar",
					"promote": "Promover",
					"cancel": "Cancelar",
					"confirmPromote": "Confirmar",
					"codeLabel": "Código",
					"defaultNameLabel": "Nome padrão",
					"commercialNameLabel": "Nome comercial",
					"kindLabel": "Tipo de vacina",
					"kindPlaceholder": "Selecione o tipo",
					"speciesLabel": "Espécies"
				},
				"errors": {
					"load": "Não foi possível carregar o dashboard.",
					"loadPets": "Não foi possível carregar o dashboard de pets.",
					"loadVaccines": "Não foi possível carregar o dashboard de vacinas.",
					"loadExams": "Não foi possível carregar o dashboard de exames.",
					"loadOthers": "Não foi possível carregar a fila de revisão.",
					"dismiss": "Não foi possível descartar o item.",
					"promote": "Não foi possível promover o item.",
					"speciesRequired": "Selecione ao menos uma espécie.",
					"kindRequired": "Selecione o tipo de vacina."
				}
			},
			"myData": {
				"saveSuccess": "Dados salvos com sucesso.",
				"saveFailed": "Não foi possível salvar. Tente novamente.",
				"loadFailed": "Não foi possível carregar seus dados.",
				"loading": "Carregando seus dados…",
				"clearColor": "Restaurar cor padrão",
				"tabsAria": "Abas de meus dados",
				"tabs": {
					"profile": "Dados pessoais",
					"alerts": "Notificações"
				},
				"form": {
					"fullNameLabel": "Nome completo",
					"fullNamePlaceholder": "Seu nome completo",
					"preferredNameLabel": "Nome preferido",
					"preferredNamePlaceholder": "Como você prefere ser chamada(o)",
					"emailLabel": "E-mail",
					"emailPlaceholder": "voce@exemplo.com",
					"phoneLabel": "Telefone",
					"phonePlaceholder": "(11) 99999-9999",
					"themeColorLabel": "Cor do sistema",
					"themeColorTooltip": "Cor para uso do sistema de forma customizada. Altere abaixo para testar. Necessário clicar em salvar para registrar a informação."
				},
				"push": {
					"title": "Notificações push",
					"description": "Receba alertas da curva glicêmica no dispositivo (somente tutor, dono do pet). Funciona melhor com o app instalado (PWA).",
					"enable": "Ativar notificações",
					"disable": "Desativar notificações",
					"enabled": "Notificações ativadas.",
					"disabled": "Notificações desativadas.",
					"failed": "Não foi possível alterar as notificações. Verifique permissão do navegador e se o PWA está ativo.",
					"unsupported": "Este navegador ou ambiente não suporta Web Push."
				},
				"alerts": {
					"hiddenTitle": "Ocultar alertas",
					"hiddenDescription": "Escolha quais tipos de alerta não devem aparecer na lista, visão geral e página de alertas.",
					"saveSuccess": "Preferências de alertas salvas.",
					"saveFailed": "Não foi possível salvar as preferências de alertas.",
					"hideKind": {
						"preventive": "Ocultar alerta: Preventivos",
						"vaccine": "Ocultar alerta: Vacinas",
						"glycemia": "Ocultar alerta: Glicemia",
						"treatment": "Ocultar alerta: Tratamentos",
						"visit": "Ocultar alerta: Consultas",
						"weight": "Ocultar alerta: Peso",
						"birthday": "Ocultar alerta: Aniversários"
					}
				}
			}
		}
	},
	"settings": {
		"preventives": {
			"tabs": {
				"brands": "Fabricantes",
				"products": "Produtos"
			},
			"active": "Ativo",
			"showDeleted": "Mostrar excluídos",
			"filters": {
				"search": "Buscar"
			},
			"actions": "Ações",
			"edit": "Editar",
			"delete": "Excluir",
			"cancel": "Cancelar",
			"brands": {
				"name": "Fabricante",
				"createTitle": "Cadastrar fabricante",
				"editTitle": "Editar fabricante"
			},
			"products": {
				"name": "Nome comercial",
				"brand": "Fabricante",
				"category": "Categoria",
				"method": "Método",
				"species": "Espécies",
				"protectionValue": "Duração da proteção",
				"protectionUnit": "Tempo",
				"aliases": "Apelidos (separados por vírgula)",
				"isOther": "Produto Outro",
				"notes": "Observações",
				"createTitle": "Cadastrar produto",
				"editTitle": "Editar produto"
			},
			"empty": {
				"brands": {
					"title": "Nenhum fabricante cadastrado",
					"description": "Cadastre o primeiro fabricante do catálogo."
				},
				"products": {
					"title": "Nenhum produto cadastrado",
					"description": "Cadastre o primeiro produto do catálogo."
				}
			},
			"noResults": {
				"title": "Nenhum resultado encontrado",
				"description": "Tente ajustar os filtros para encontrar o que procura."
			},
			"errors": {
				"load": "Não foi possível carregar o catálogo.",
				"save": "Não foi possível salvar o catálogo.",
				"species": "Selecione ao menos uma espécie.",
				"delete": "Não foi possível excluir o item."
			},
			"success": {
				"save": "Catálogo salvo com sucesso.",
				"delete": "Item excluído com sucesso."
			}
		}
	},
	"breeds": {
		"notInformed": "Não informado",
		"breedPlaceholder": "Selecione a raça",
		"otherBreedLabel": "Descrição da raça",
		"otherBreedPlaceholder": "Informe a raça",
		"coatLabel": "Pelagem",
		"coatLengthLabel": "Comprimento da pelagem",
		"coatColorsLabel": "Cores da pelagem",
		"coatColorsSearch": "Buscar cor",
		"otherColorLabel": "Outra cor",
		"otherColorPlaceholder": "Descreva a cor",
		"lengths": {
			"hairless": "Sem pelo",
			"short": "Curta",
			"medium": "Média",
			"long": "Longa"
		},
		"colors": {
			"white": "Branco",
			"black": "Preto",
			"gray": "Cinza",
			"silver": "Prateado",
			"blue": "Azul",
			"brown": "Marrom",
			"chocolate": "Chocolate",
			"liver": "Fígado",
			"tan": "Tan",
			"cream": "Creme",
			"beige": "Bege",
			"fawn": "Fulvo",
			"yellow": "Amarelo",
			"golden": "Dourado",
			"orange": "Laranja",
			"red": "Vermelho",
			"cinnamon": "Canela",
			"lilac": "Lilás",
			"caramel": "Caramelo",
			"sable": "Sable",
			"smoke": "Smoke",
			"other": "Outra"
		}
	},
	"infos": {
		"photo": "Foto",
		"selectPhoto": "Selecionar foto",
		"removePhoto": "Remover foto",
		"name": "Nome",
		"age": "Idade",
		"birth": "Nascimento",
		"adoptionTime": "Tempo adoção",
		"adoptionDate": "Data de adoção",
		"specie": "Espécie",
		"race": "Raça",
		"sex": "Sexo",
		"coat": "Pelagem",
		"microchip": "Microchip",
		"microchipAbsent": "Não possui microchip",
		"themeColor": "Cor para o pet no sistema",
		"themeColorTooltip": "Cor para uso do sistema de forma customizada. Altere abaixo para testar. Necessário clicar em salvar para registrar a informação",
		"photoUpload": {
			"selected": "Foto \"{{fileName}}\" selecionada. Clique em salvar para registrar.",
			"dropzone": "Arraste e solte a foto aqui",
			"dropActive": "Solte a foto para enviar",
			"browse": "ou clique para procurar",
			"constraints": "Formatos aceitos: JPG, PNG, WebP até 5MB",
			"disabled": "Upload de foto desabilitado",
			"uploading": "Enviando foto...",
			"existingMeta": "Imagem Pet",
			"cropAction": "Editar imagem (recortar)",
			"cancelUploadAria": "Cancelar envio",
			"removeFileAria": "Remover arquivo",
			"invalidFileType": "Tipo de arquivo não permitido",
			"fileTooLarge": "Arquivo excede o tamanho máximo (__MAX_SIZE__)",
			"uploadFailed": "Não foi possível enviar o arquivo",
			"unknownExtension": "ARQUIVO",
			"cropper": {
				"title": "Recortar imagem",
				"cancel": "Cancelar",
				"apply": "Aplicar recorte",
				"zoom": "Zoom",
				"ratio": "Proporção",
				"rotateLeftAria": "Girar para a esquerda",
				"rotateRightAria": "Girar para a direita",
				"aspectFree": "Livre",
				"aspectSquare": "Quadrado (1:1)",
				"aspectFourThree": "4:3",
				"aspectSixteenNine": "16:9"
			}
		},
		"previewExpand": "Ampliar imagem",
		"healthCare": {
			"success": "Saúde e cuidado atualizados com sucesso.",
			"errors": {
				"genericTitle": "Erro ao salvar",
				"genericMessage": "Não foi possível salvar os dados de saúde e cuidado. Tente novamente."
			},
			"neuteredStatus": {
				"label": "Castrado",
				"options": {
					"yes": "Sim",
					"no": "Não",
					"unknown": "Desconhecido"
				}
			},
			"castrationDate": {
				"label": "Data da castração"
			},
			"origin": {
				"label": "Origem do animal",
				"options": {
					"breeder": "Criador",
					"shelter": "Abrigo / ONG",
					"rescue": "Resgate",
					"born_at_home": "Nascido em casa",
					"other": "Outro"
				}
			},
			"originOther": {
				"label": "Origem — Outro",
				"placeholder": "Descreva a origem do animal"
			},
			"livingEnvironment": {
				"label": "Ambiente de vida",
				"options": {
					"indoor_only": "Indoor — dentro de casa apenas",
					"outdoor_yard_only": "Outdoor — fora de casa apenas (quintal)",
					"outdoor_yard_street_access": "Outdoor — fora de casa (quintal + acesso à rua livre)",
					"mixed_no_street_access": "Misto — dentro e fora de casa sem acesso à rua livre",
					"mixed_with_street_access": "Misto — dentro e fora de casa com acesso à rua livre"
				}
			},
			"allergies": {
				"label": "Alergias",
				"placeholder": "Descreva alergias conhecidas do animal (medicamentos, alimentos, ambientais, etc.)"
			},
			"feeding": {
				"label": "Alimentação",
				"placeholder": "Nome da ração ou alimentação habitual",
				"labelTooltip": "Nome da ração ou descreva alimentação diária do animal como alimentação natural e o que ele come"
			}
		},
		"new": {
			"title": "Cadastrar pet",
			"subtitle": "Preencha os dados abaixo para registrar o seu pet no sistema"
		},
		"time": {
			"and": "e",
			"year": "{count, plural, one {# ano} other {# anos}}",
			"month": "{count, plural, one {# mês} other {# meses}}",
			"day": "{count, plural, one {# dia} other {# dias}}"
		}
	},
	"loading": {
		"trying": "Carregando...",
		"noResults": "Nenhuma informação encontrada",
		"endOfList": "Fim da lista"
	},
	"menu": {
		"expand": "Expandir menu",
		"collapse": "Recolher menu",
		"language": {
			"label": "Idioma",
			"ariaLabel": "Idioma atual",
			"options": {
				"pt": "Português",
				"en": "Inglês",
				"es": "Espanhol",
				"fr": "Francês"
			}
		},
		"principal": {
			"title": "Pets",
			"profiles": {
				"master": {
					"title": "Gestão de pets",
					"subtitle": "Gerencie seus pets e acompanhe pets de outros tutores quando necessário"
				},
				"vet": {
					"title": "Pets compartilhados comigo",
					"subtitle": "Acompanhe pets autorizados por tutores e consulte seus históricos"
				},
				"user": {
					"title": "Meus pets",
					"subtitle": "Acompanhe seus pets, alertas e informações importantes em um só lugar"
				}
			},
			"type": "pet",
			"petsList": "Lista de Pets",
			"alerts": "Alertas",
			"registerPet": "Cadastrar pet"
		},
		"pet": {
			"title": "Pet",
			"overview": {
				"title": "Visão geral",
				"subtitle": "Resumo das informações de saúde e cuidados do pet"
			},
			"alerts": {
				"title": "Alertas",
				"subtitle": "Alertas e pendências deste pet"
			},
			"edit": {
				"title": "Editar pet",
				"subtitle": "Atualize os dados básicos do seu pet",
				"tabs": {
					"general": "Dados Gerais",
					"healthCare": "Saúde & Cuidado",
					"feeding": "Alimentação",
					"access": "Acessos",
					"aria": "Seções de edição do pet"
				},
				"success": "Pet atualizado com sucesso.",
				"errors": {
					"conflictTitle": "Não foi possível salvar",
					"conflictMessage": "Já existe um registro com esses dados.",
					"invalidTitle": "Dados inválidos",
					"invalidMessage": "Revise os campos e tente novamente.",
					"forbiddenTitle": "Sem permissão",
					"forbiddenMessage": "Sua sessão pode ter expirado. Faça login novamente.",
					"photoTooLargeTitle": "Foto muito grande",
					"photoTooLargeMessage": "A imagem excede o limite de 5 MB. Escolha um arquivo menor.",
					"photoTypeTitle": "Formato não suportado",
					"photoTypeMessage": "Use uma imagem JPG, PNG ou WebP.",
					"genericTitle": "Erro ao salvar o pet",
					"genericMessage": "Tente novamente em alguns instantes."
				}
			},
			"new": {
				"success": "Pet cadastrado com sucesso.",
				"errors": {
					"conflictTitle": "Não foi possível cadastrar",
					"conflictMessage": "Já existe um registro com esses dados.",
					"invalidTitle": "Dados inválidos",
					"invalidMessage": "Revise os campos e tente novamente.",
					"forbiddenTitle": "Sem permissão",
					"forbiddenMessage": "Sua sessão pode ter expirado. Faça login novamente.",
					"photoTooLargeTitle": "Foto muito grande",
					"photoTooLargeMessage": "A imagem excede o limite de 5 MB. Escolha um arquivo menor.",
					"photoTypeTitle": "Formato não suportado",
					"photoTypeMessage": "Use uma imagem JPG, PNG ou WebP.",
					"genericTitle": "Erro ao cadastrar o pet",
					"genericMessage": "Tente novamente em alguns instantes."
				}
			},
			"weight": {
				"title": "Pesos",
				"subtitle": "Histórico de pesagem e evolução do peso"
			},
			"preventives": {
				"title": "Preventivos",
				"subtitle": "Controle de anti-pulgas e vermífugos",
				"type": "Preventivo",
				"new": "Novo registro",
				"newSubtitle": "Registre a aplicação de preventivo do pet",
				"edit": "Editar registro",
				"editSubtitle": "Atualize os dados do preventivo"
			},
			"veterinaryConsultation": {
				"title": "Consultas",
				"subtitle": "Histórico de consultas veterinárias",
				"type": "Consulta",
				"new": "Nova visita ao veterinário",
				"newSubtitle": "Registre a consulta e os principais achados clínicos",
				"edit": "Editar visita ao veterinário",
				"editSubtitle": "Atualize as informações da consulta"
			},
			"vaccines": {
				"title": "Vacinas",
				"subtitle": "Registro de vacinas aplicadas ao pet",
				"type": "Vacina",
				"new": "Nova aplicação de vacina",
				"newSubtitle": "Informe o contexto, o local e os dados da aplicação",
				"edit": "Editar aplicação da vacina",
				"editSubtitle": "Atualize os dados da aplicação de vacina"
			},
			"examsResults": {
				"title": "Resultados de exames",
				"subtitle": "Resultados e histórico de exames solicitados nas consultas",
				"type": "Exames",
				"new": "Novo resultado de exame",
				"newSubtitle": "Registre exames históricos com data, valores e anexos",
				"edit": "Editar resultado de exame",
				"editSubtitle": "Atualize os dados do pedido e os valores dos exames"
			},
			"examsResultsDetails": {
				"title": "Detalhes dos resultados do exame",
				"subtitle": "Informações do exame realizado"
			},
			"examsComparisons": {
				"title": "Comparações de exames",
				"subtitle": "Evolução + faixa de referência",
				"type": "Exames"
			},
			"treatments": {
				"title": "Tratamentos",
				"subtitle": "Tratamentos contínuos ou temporários",
				"type": "Tratamento",
				"new": "Novo tratamento",
				"newSubtitle": "Cadastre um tratamento em andamento ou temporário",
				"edit": "Editar tratamento",
				"editSubtitle": "Atualize as informações do tratamento",
				"view": "Ver tratamento",
				"viewSubtitle": "Plano finalizado — apenas notas podem ser adicionadas"
			},
			"clinicalConditions": {
				"title": "Condições clínicas",
				"subtitle": "Doenças e condições de saúde acompanhadas",
				"type": "Condição",
				"details": "Condição: {name}",
				"detailsSubtitle": "Acompanhe o histórico e as anotações desta condição",
				"new": "Nova condição clínica",
				"newSubtitle": "Registre uma condição clínica do pet",
				"edit": "Editar condição clínica",
				"editSubtitle": "Atualize os dados da condição clínica"
			},
			"glucoseCurveMeasures": {
				"title": "Medições glicêmicas",
				"subtitle": "Acompanhamento das medições da curva glicêmica",
				"type": "Medição",
				"new": "Nova medição de curva glicêmica",
				"newSubtitle": "Registre uma nova sessão de curva glicêmica",
				"details": "Medição de {date}",
				"detailsFallback": "Medição",
				"detailsSubtitle": "Detalhes e pontos da curva glicêmica"
			},
			"glucoseCurveComparison": {
				"title": "Comparação glicêmica",
				"subtitle": "Evolução da glicemia ao longo do tempo",
				"type": "Medição"
			},
			"glycemia": {
				"title": "Glicemia",
				"subtitle": "Controle diário, curva e comparação"
			}
		},
		"vet": {
			"title": "Meus pets compartilhados",
			"subtitle": "Escolha um pet para ver informações e histórico"
		},
		"admin": {
			"title": "Cadastros admin",
			"dashboard": "Dashboard",
			"dashboardSubtitle": "Visão geral de pets, aplicações de vacinas e fila de revisão",
			"typesOfVaccines": "Vacina",
			"typesOfVaccinesSubtitle": "Tipos, marcas, produtos e fila de revisão de textos livres",
			"preventivesCatalog": "Preventivos",
			"preventivesCatalogSubtitle": "Marcas e produtos preventivos",
			"diseases": "Doenças",
			"diseasesSubtitle": "Cadastre e gerencie doenças vinculadas a vacinas e condições",
			"breeds": "Raças",
			"breedsSubtitle": "Raças, cores de pelagem e fila de revisão",
			"exams": "Exames",
			"examsSubtitle": "Catálogo, painéis, auditoria e importações de exames",
			"typesOfExams": "Tipos de exames",
			"typesOfExamsSubtitle": "Cadastre tipos de exame e referências do sistema",
			"examinationPackage": "Pacotes de exames",
			"examinationPackageSubtitle": "Monte pacotes com conjuntos de exames",
			"adminUsers": "Usuários do sistema",
			"adminUsersSubtitle": "Gerencie tutores, veterinários e status de acesso",
			"audit": "Auditoria",
			"auditSubtitle": "Logs de autenticação e ações administrativas",
			"myDataSubtitle": "Dados pessoais e preferências de notificações"
		},
		"fixed": {
			"myData": "Minha conta",
			"mySettings": "Minhas configurações",
			"logout": "Sair"
		},
		"goBackTo": {
			"principal": "Voltar aos pets"
		}
	},
	"overview": {
		"microchipAbsent": "Não possui",
		"titles": {
			"infos": "Informações do pet",
			"nextVaccines": "Próximas vacinas",
			"lastWeighIns": "Últimas pesagens",
			"glycemicCurve": "Curva glicêmica",
			"glycemicCurveComparison": "Comparação últimas curvas"
		},
		"fields": {
			"microchip": "Microchip"
		},
		"weights": {
			"from": "De",
			"to": "Até",
			"startDate": "Data inicial",
			"endDate": "Data final",
			"dateAxis": "Data",
			"weightAxis": "Peso (kg)",
			"lastWeighIn": "Última pesagem:",
			"onDate": "em",
			"noRecords": "Sem registro",
			"gained": "ganhou",
			"lost": "perdeu",
			"maintained": "manteve",
			"inPeriod": "no período.",
			"open": "Registrar / Ver pesos",
			"errors": {
				"endBeforeStart": "A data final não pode ser menor que a inicial.",
				"sameDates": "As datas não podem ser iguais. Selecione duas diferentes."
			}
		},
		"glycemia": {
			"measurementDate": "Data da medição:",
			"minimum": "Mín:",
			"maximum": "Máx:",
			"average": "Média:",
			"clicks": "cliques",
			"register": "Registrar glicemia",
			"viewMeasurement": "Ver medição realizada"
		},
		"completeness": {
			"title": "Infos faltando preencher",
			"lead": "Campos básicos e importantes ainda sem preenchimento neste pet:",
			"badgeOk": "Completo",
			"badgeMissing": "{count} pendente(s)",
			"emptyTitle": "Todas as informações básicas e importantes preenchidas",
			"emptyDescription": "Cadastro geral, saúde/cuidado, vacinas e peso estão ok neste pet.",
			"vaccinesTotal": "Vacinas cadastradas",
			"weightsTotal": "Pesos cadastrados",
			"fields": {
				"microchip": "Microchip",
				"birthDate": "Data de nascimento",
				"adoptionDate": "Data de adoção",
				"breed": "Raça",
				"coatLength": "Comprimento da pelagem",
				"coatColors": "Cor da pelagem",
				"neuteredStatus": "Castrado (sim / não / desconhecido)",
				"castrationDate": "Data da castração",
				"origin": "Origem do animal",
				"livingEnvironment": "Ambiente de vida",
				"feeding": "Alimentação",
				"vaccines": "Nenhuma vacina registrada",
				"weights": "Nenhum peso registrado"
			}
		}
	},
	"toast": {
		"successTitle": "Sucesso!",
		"errorTitle": "Erro!",
		"warningTitle": "Atenção",
		"infoTitle": "Informação"
	},
	"uiKit": {
		"form": {
			"selectPlaceholder": "Selecione",
			"searchPlaceholder": "Buscar...",
			"searchAriaLabel": "Buscar opção",
			"emptyOptions": "Nenhuma opção encontrada",
			"clearSelectionAria": "Limpar seleção"
		},
		"table": {
			"paginationAria": "Paginação da tabela",
			"paginationTopSuffix": "(superior)",
			"paginationBottomSuffix": "(inferior)",
			"previous": "Anterior",
			"next": "Próxima",
			"first": "Primeira",
			"last": "Última",
			"page": "Página",
			"of": "de",
			"total": "registro(s)",
			"pageSizeAria": "Itens por página",
			"sortBy": "Ordenar por __COLUMN__",
			"sortAsc": "crescente",
			"sortDesc": "decrescente"
		},
		"modal": {
			"confirm": "Confirmar",
			"cancel": "Cancelar",
			"close": "Fechar",
			"closeAria": "Fechar modal"
		},
		"toast": {
			"closeAria": "Fechar notificação"
		},
		"loading": {
			"ariaLabel": "Carregando conteúdo"
		},
		"tabs": {
			"ariaLabel": "Abas"
		},
		"breadcrumb": {
			"ariaLabel": "Navegação estrutural"
		},
		"switch": {
			"active": "Ativado",
			"inactive": "Desativado"
		},
		"button": {
			"loading": "Carregando..."
		},
		"alert": {
			"closeAria": "Fechar alerta"
		},
		"fileUpload": {
			"pdfBadge": "pdf"
		}
	},
	"vaccines": {
		"kinds": {
			"BORDETELLA": "Bordetella",
			"FELV": "FeLV",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniose",
			"CANINE_PUPPY": "Puppy",
			"RABIES": "Raiva",
			"TOSSE": "Tosse e gripe canina",
			"CANINE_V10": "V10",
			"CANINE_V11": "V11",
			"FELINE_V3": "V3",
			"FELINE_V4": "V4",
			"FELINE_V5": "V5",
			"CANINE_V6": "V6",
			"CANINE_V8": "V8",
			"OTHER": "Outra"
		},
		"diseases": {
			"RABIES": "Raiva",
			"CANINE_DISTEMPER": "Cinomose",
			"CANINE_ADENOVIRUS": "Adenovírus / Hepatite",
			"CANINE_PARVOVIRUS": "Parvovirose",
			"CANINE_PARAINFLUENZA": "Parainfluenza",
			"LEPTOSPIROSIS": "Leptospirose",
			"BORDETELLA": "Bordetella / Tosse dos canis",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniose",
			"FELINE_HERPESVIRUS": "Rinotraqueíte felina",
			"FELINE_CALICIVIRUS": "Calicivírus felino",
			"FELINE_PANLEUKOPENIA": "Panleucopenia felina",
			"FELINE_CHLAMYDIA": "Clamidiose felina",
			"FELINE_LEUKEMIA": "Leucemia felina (FeLV)"
		},
		"dose": {
			"unique": "única",
			"nth": "{n}ª dose",
			"last": "última dose"
		},
		"product": {
			"notInformed": "Não informada"
		},
		"context": {
			"consultation": "Consulta veterinária",
			"home": "Atendimento domiciliar",
			"campaign": "Campanha pública",
			"shelter_ngo": "ONG / Abrigo",
			"hospital": "Hospital veterinário",
			"breeder": "Criador (canil/gatil)",
			"university": "Universidade",
			"other": "Outro"
		},
		"visitType": {
			"routine": "Rotina",
			"return": "Retorno",
			"emergency": "Urgência"
		},
		"visitMode": {
			"in_person": "Presencial",
			"home": "Domicílio",
			"tele": "Teleatendimento"
		},
		"locationType": {
			"clinic": "Clínica",
			"home": "Residência",
			"public_event": "Evento / campanha",
			"shelter": "Abrigo / ONG",
			"hospital": "Hospital",
			"breeder": "Criador",
			"university": "Universidade",
			"pet_shop": "Pet shop",
			"other": "Outro"
		},
		"form": {
			"kindLabel": "Tipo de vacina",
			"kindPlaceholder": "Selecione o tipo…",
			"productLabel": "Produto / marca comercial",
			"productPlaceholder": "Selecione o produto…",
			"otherKindLabel": "Nome do tipo",
			"otherKindPlaceholder": "Informe o tipo de vacina",
			"otherProductLabel": "Nome do produto",
			"otherProductPlaceholder": "Informe o produto",
			"doseLabel": "Dose",
			"contextLabel": "Contexto da aplicação",
			"contextPlaceholder": "Selecione o contexto…",
			"locationNameLabel": "Local",
			"locationNamePlaceholder": "Buscar clínica ou local",
			"clinicOther": "Outro",
			"clinicNameLabel": "Nome do local",
			"clinicNamePlaceholder": "Ex.: Clínica X, CCZ…",
			"homeLocationFixed": "Residência",
			"visitTypeLabel": "Tipo da consulta",
			"visitTypePlaceholder": "Selecione o tipo…",
			"visitModeLabel": "Modelo da consulta",
			"visitModePlaceholder": "Selecione o modelo…",
			"weightLabel": "Peso (kg)",
			"weightPlaceholder": "Ex.: 4,5",
			"weightReplaceTitle": "Substituir peso do dia?",
			"weightReplaceDescription": "Já existe peso de {existing} kg neste dia. Deseja substituir por {next} kg?",
			"weightReplaceConfirm": "Substituir",
			"weightReplaceSkip": "Manter peso atual",
			"visitLabel": "Consulta relacionada",
			"visitPlaceholder": "Selecione a consulta…",
			"administeredAtLabel": "Aplicada em",
			"administeredAtTimeLabel": "Horário",
			"nextDoseLabel": "Próxima dose",
			"administeredByLabel": "Profissional",
			"vetCrmvLabel": "CRMV",
			"vetCrmvPlaceholder": "Ex.: CRMV-SP 12345",
			"clinicLabel": "Clínica",
			"notesLabel": "Observações / efeitos",
			"notesPlaceholder": "Anote reações, efeitos ou complicações observadas…",
			"visitInternalNotes": "Aplicação de vacina",
			"kindOrProductHint": "Pode escolher o tipo, o produto, ou só o produto — o tipo é preenchido automaticamente.",
			"dosesSingular": "1 dose",
			"dosesPlural": "{count} doses",
			"successSave": "Vacina salva com sucesso.",
			"errorSave": "Não foi possível salvar a vacina. Tente novamente.",
			"addVaccine": "Adicionar vacina",
			"removeVaccine": "Remover vacina",
			"sectionTitle": "Vacinas aplicadas",
			"vaccinesSectionHint": "Para cada vacina aplicada neste dia, informe o tipo, o produto e a data da próxima dose.",
			"cancel": "Cancelar"
		}
	},
	"preventives": {
		"form": {
			"loading": "Carregando preventivo…",
			"appliedAtLabel": "Data da aplicação",
			"kindLabel": "Qual",
			"kindPlaceholder": "Selecione…",
			"methodLabel": "Tipo",
			"methodPlaceholder": "Selecione…",
			"productLabel": "Produto",
			"productPlaceholder": "Ex.: NexGard, Bravecto…",
			"productCatalogPlaceholder": "Busque um produto…",
			"otherProduct": "Outro / não listado",
			"otherProductLabel": "Nome do produto",
			"protectionValueLabel": "Duração de proteção",
			"protectionValuePlaceholder": "Ex.: 30",
			"protectionUnitLabel": "Tempo",
			"protectionUnitPlaceholder": "Selecione…",
			"unitDays": "Dias",
			"unitMonths": "Meses",
			"recurringLabel": "Aplicação recorrente",
			"recurringTooltip": "Quando marcado, gera alerta na home com base na próxima dose.",
			"nextDueAtLabel": "Próxima dose",
			"calculateNextDue": "Calcular próxima data",
			"recalculate": "Recalcular",
			"autoSuggestion": "Sugestão automática: {date}",
			"weightLabel": "Peso no dia (kg)",
			"weightPlaceholder": "Ex.: 4,5",
			"weightReplaceTitle": "Substituir peso do dia?",
			"weightReplaceDescription": "Já existe peso de {existing} kg neste dia. Deseja substituir por {next} kg?",
			"weightReplaceConfirm": "Substituir",
			"weightReplaceSkip": "Manter peso atual",
			"notesLabel": "Observações",
			"notesPlaceholder": "Adicione observações",
			"sourceTreatmentLabel": "Tratamento de origem",
			"sourceTreatmentPlaceholder": "Vincular a um tratamento",
			"cancel": "Cancelar",
			"success": {
				"create": "Preventivo cadastrado com sucesso.",
				"update": "Preventivo atualizado com sucesso."
			},
			"errors": {
				"load": "Não foi possível carregar o preventivo.",
				"save": "Não foi possível salvar o preventivo.",
				"recalculate": "Não foi possível recalcular a próxima dose."
			}
		},
		"categories": {
			"pulgas_carrapatos": "Pulgas e carrapatos",
			"pulgas": "Pulgas",
			"vermifugo": "Vermífugo",
			"vermifugo_dirofilariose": "Vermífugo e dirofilariose",
			"combo_interno_externo": "Proteção interna e externa",
			"outro": "Outro"
		},
		"methods": {
			"comprimido": "Comprimido",
			"injecao": "Injeção",
			"coleira": "Coleira",
			"pipeta": "Pipeta",
			"spray": "Spray",
			"shampoo": "Shampoo",
			"liquido": "Líquido",
			"pasta": "Pasta",
			"outro": "Outro"
		}
	},
	"appUpdate": {
		"title": "Nova versão disponível",
		"message": "Há uma atualização do sistema pronta. Atualize para carregar textos e correções novas.",
		"reload": "Atualizar agora",
		"later": "Depois",
		"errorTitle": "Atualização",
		"unrecoverable": "O app precisa recarregar para continuar."
	},
	"offline": {
		"banner": "Sem conexão. Seus dados deste formulário permanecem neste dispositivo e poderão ser enviados quando a conexão voltar."
	},
	"weight": {
		"loading": "Carregando histórico de pesos",
		"readOnlyInfo": "Somente o tutor do pet pode cadastrar ou excluir pesos.",
		"unit": {
			"kg": "kg"
		},
		"form": {
			"panelTitle": "Cadastrar novo peso"
		},
		"tabs": {
			"aria": "Visões do peso",
			"summary": "Resumo",
			"stats": "Estatística",
			"timeline": "Timeline"
		},
		"summary": {
			"initial": "Peso inicial",
			"current": "Peso atual",
			"last": "Último peso",
			"trend": "Tendência"
		},
		"trend": {
			"up": "Ganho de peso",
			"down": "Perda de peso",
			"flat": "Peso estável"
		},
		"stats": {
			"loading": "Carregando estatísticas",
			"periodNote": "* Dados estatísticos com base nos últimos 12 meses.",
			"insufficient": {
				"title": "Dados insuficientes",
				"description": "É necessário ter pelo menos 2 registros de peso nos últimos 12 meses para exibir as estatísticas."
			},
			"max": "Maior peso",
			"min": "Menor peso",
			"average": "Peso médio",
			"averageBasis": "Com base em {count} registros",
			"amplitude": "Amplitude",
			"amplitudeMeta": "Entre menor e maior peso",
			"lastWeighing": "Última pesagem",
			"lastWeighingToday": "Hoje",
			"lastWeighingOneDay": "Há 1 dia",
			"lastWeighingDays": "Há {days} dias",
			"ratePerWeek": "Variação média",
			"ratePerWeekMeta": "Do primeiro ao último registro do período",
			"ratePerWeekValue": "{value} kg/semana",
			"frequency": "Frequência",
			"frequencyMeta": "Intervalo médio entre registros",
			"frequencyDays": "A cada {days} dias",
			"frequencyOneDay": "Diária em média",
			"notAvailable": "—",
			"trend": "Tendência",
			"error": {
				"title": "Não foi possível carregar as estatísticas",
				"description": "Ocorreu um erro ao calcular as estatísticas de peso. Tente novamente.",
				"retry": "Tentar novamente"
			}
		},
		"timeline": {
			"sortAria": "Alternar ordem da linha do tempo",
			"sortNewest": "Mais recentes primeiro",
			"sortOldest": "Mais antigos primeiro",
			"loadingMore": "Carregando mais registros"
		},
		"empty": {
			"title": "Nenhum peso registrado",
			"description": "Acompanhe o desenvolvimento do seu pet! O peso é algo extremamente importante!",
			"descriptionReadOnly": "Não há peso registrado para esse pet."
		},
		"loadError": {
			"title": "Não foi possível carregar os pesos",
			"description": "Ocorreu um erro ao buscar o histórico de pesos. Tente novamente.",
			"retry": "Tentar novamente"
		},
		"errors": {
			"save": "Não foi possível salvar o peso. Tente novamente.",
			"duplicateDate": "Já existe peso registrado nesse dia",
			"delete": "Não foi possível excluir o registro. Tente novamente.",
			"loadMore": "Não foi possível carregar mais registros."
		},
		"success": {
			"save": "Peso registrado com sucesso.",
			"delete": "Registro de peso excluído."
		},
		"delete": {
			"title": "Excluir registro de peso?",
			"contentWithRecord": "Essa ação não pode ser desfeita. Registro: {record}",
			"contentGeneric": "Essa ação não pode ser desfeita.",
			"confirm": "Excluir",
			"cancel": "Cancelar"
		},
		"actions": {
			"deleteAria": "Excluir registro de peso"
		}
	},
	"feeding": {
		"loading": "Carregando alimentação",
		"historyTitle": "Histórico",
		"changedFeeding": "Mudei a alimentação",
		"stoppedFeeding": "Parei de dar",
		"stop": {
			"title": "Parar alimentação",
			"description": "Deseja encerrar \"{product}\"? Ela irá para o histórico e não será substituída.",
			"confirm": "Parar",
			"cancel": "Cancelar"
		},
		"history": {
			"from": "De: {date}",
			"to": "Até: {date}"
		},
		"card": {
			"since": "Desde {date}",
			"notesPrefix": "Obs.: "
		},
		"empty": {
			"activeTitle": "Nenhuma alimentação cadastrada",
			"activeDescription": "Cadastre a ração ou alimentação atual do pet para acompanhar mudanças ao longo do tempo.",
			"historyTitle": "Sem histórico",
			"historyDescription": "Quando uma alimentação for substituída, ela aparecerá aqui."
		},
		"form": {
			"titleAdd": "Adicionar alimento",
			"titleChange": "Mudei a alimentação",
			"type": "Tipo",
			"product": "Produto",
			"productPlaceholder": "Selecione um produto do catálogo",
			"productOther": "Outro",
			"brandName": "Marca",
			"brandNamePlaceholder": "Ex.: Royal Canin",
			"productName": "Nome do produto",
			"productNamePlaceholder": "Ex.: ração adult, comida natural",
			"flavor": "Sabor",
			"flavorPlaceholder": "Ex.: frango",
			"purpose": "Finalidade",
			"format": "Formato",
			"frequencyUnit": "Frequência",
			"frequencyTimes": "Vezes",
			"frequencyTimesPlaceholder": "Ex.: 2",
			"frequencyOther": "Descreva a frequência",
			"frequencyOtherPlaceholder": "Ex.: a cada 2 dias, só aos fins de semana",
			"startDate": "Data de início",
			"endDate": "Data de término da anterior",
			"notes": "Observações",
			"notesPlaceholder": "Adicione observações"
		},
		"type": {
			"dry_food": "Ração seca",
			"wet_food": "Ração úmida",
			"natural_home_cooked": "Natural caseira",
			"natural_commercial": "Natural comercial",
			"raw_diet": "Dieta crua (BARF)",
			"milk_formula": "Fórmula / leite",
			"enteral_diet": "Dieta enteral",
			"other": "Outro"
		},
		"purpose": {
			"maintenance": "Manutenção",
			"growth": "Crescimento",
			"weight_control": "Controle de peso",
			"therapeutic": "Terapêutica",
			"recovery": "Recuperação",
			"senior": "Sênior",
			"other": "Outro"
		},
		"format": {
			"kibble": "Croquete",
			"sachet": "Sachê",
			"can": "Lata",
			"pate": "Patê",
			"mousse": "Mousse",
			"frozen": "Congelado",
			"refrigerated": "Refrigerado",
			"dehydrated": "Desidratado",
			"freeze_dried": "Liofilizado",
			"liquid": "Líquido",
			"other": "Outro"
		},
		"frequency": {
			"unit": {
				"day": "Por dia",
				"week": "Por semana",
				"free": "Livre",
				"other": "Outra"
			},
			"label": {
				"day": "{times}x por dia",
				"week": "{times}x por semana",
				"free": "Livre (sempre disponível)"
			}
		},
		"success": {
			"create": "Alimento adicionado com sucesso.",
			"change": "Alimentação atualizada com sucesso.",
			"stop": "Alimentação encerrada com sucesso."
		},
		"errors": {
			"loadTitle": "Não foi possível carregar",
			"loadMessage": "Ocorreu um erro ao buscar a alimentação. Tente novamente.",
			"saveTitle": "Não foi possível salvar",
			"saveMessage": "Revise os campos e tente novamente.",
			"stopMessage": "Não foi possível encerrar a alimentação. Tente novamente."
		}
	},
	"table": {
		"totalCount": "<span class='hide-mobile'>Total de </span><strong>{ total }</strong> registros"
	},
	"noResults": {
		"vaccines": "Sem próximas vacinas"
	}
}
